"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4319],{

/***/ 53754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10092);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _src_client_pages_insurance_queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);







/*
  We retrieve products from sanity by getting the product types for an insurance type first. Then we get the products for each of the types.
*/ // @ts-expect-error - Automatic, Please fix when editing this file
var getProductsByType = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var client, type, productTypeData, productTypes, ref, products, bestSellers, groupedByProductType, bestSellerIds, sortedProductsArray;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = param.client, type = param.type;
                    return [
                        4,
                        client(_src_client_pages_insurance_queries__WEBPACK_IMPORTED_MODULE_1__/* .GET_PRODUCT_TYPES_BY_INSURANCE_TYPE_QUERY */ .LE, {
                            variables: {
                                type: type
                            }
                        })
                    ];
                case 1:
                    productTypeData = _state.sent();
                    productTypes = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)("identifier.current", productTypeData.allProductType);
                    return [
                        4,
                        Promise.all([
                            client(_src_client_pages_insurance_queries__WEBPACK_IMPORTED_MODULE_1__/* .GET_PRODUCTS_BY_TYPE_QUERY */ .hT, {
                                variables: {
                                    productTypes: productTypes
                                }
                            }),
                            client(_src_client_pages_insurance_queries__WEBPACK_IMPORTED_MODULE_1__/* .GET_BEST_SELLERS_QUERY */ .xv, {
                                variables: {
                                    productTypes: productTypes
                                }
                            })
                        ])
                    ];
                case 2:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), products = ref[0], bestSellers = ref[1];
                    groupedByProductType = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.groupBy)("productType.identifier.current", products === null || products === void 0 ? void 0 : products.allProduct);
                    bestSellerIds = new Set((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)("product.identifier.current", bestSellers === null || bestSellers === void 0 ? void 0 : bestSellers.allBestSeller));
                    sortedProductsArray = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(productType) {
                        return {
                            productType: productType,
                            products: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(product) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, product), {
                                    isBestSeller: bestSellerIds.has(product.identifier.current)
                                });
                            }, groupedByProductType[productType])
                        };
                    }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.keys)(groupedByProductType));
                    return [
                        2,
                        sortedProductsArray
                    ];
            }
        });
    });
    return function getProductsByType(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (getProductsByType);


/***/ }),

/***/ 20194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64355);
/* harmony import */ var _ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




// the order of the properties isn't necessary, but makes schema verifying tools output clearer to read
// the schema can be verified with: https://search.google.com/test/rich-results and https://validator.schema.org/
var buildQuestionAndAnswer = function(FAQ) {
    var body = FAQ.body, title = FAQ.title;
    return {
        "@type": "Question",
        name: title,
        // eslint-disable-next-line sort-keys
        acceptedAnswer: {
            "@type": "Answer",
            text: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isArray)(body) ? _ahmdigital_logic_lib_content_utils_portable_text_to_plain__WEBPACK_IMPORTED_MODULE_2___default()(body) : body
        }
    };
};
var FAQStructuredContentBlock = function(param) {
    var faqs = param.faqs;
    if (!faqs) return null;
    var builtQuestionsAndAnswers = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.map)(buildQuestionAndAnswer, faqs);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        type: "application/ld+json",
        "data-testid": "faq-schema",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "FAQPage",
                mainEntity: builtQuestionsAndAnswers
            })
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQStructuredContentBlock);


/***/ }),

/***/ 83697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ quick_links; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/quick-links/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  max-width: 84.5rem;\n  padding: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin: 1.5rem 0 0;\n  padding: 0 0.75rem;\n  &:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-81791583-0"
})(_templateObject());
var LinkWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-81791583-1"
})(_templateObject1());
var StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-81791583-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.purple;
}, function(param) {
    var theme = param.theme;
    return theme.colors.purple;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});

;// CONCATENATED MODULE: ./src/client/components/quick-links/index.tsx





var QuickLinks = function(param) {
    var title = param.title, links = param.links, _isBrowserHandled = param.isBrowserHandled, isBrowserHandled = _isBrowserHandled === void 0 ? false : _isBrowserHandled;
    if ((0,fp.isEmpty)(links)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSection, {
                variant: [
                    "paddingTopSpacer5",
                    "paddingBottomSpacer5"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
                    variant: "center",
                    children: [
                        title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                            variant: "marginBottomSpacer8",
                            children: title
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
                            children: (0,fp.map)(function(link) {
                                return link.name && link.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClickable, {
                                    isBrowserHandled: isBrowserHandled,
                                    to: link.url,
                                    children: link.name
                                }, JSON.stringify(link)) : null;
                            }, links)
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var quick_links = (QuickLinks);


/***/ }),

/***/ 96709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ article_metadata; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/pages/blog-detail/components/article-metadata/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: ",
        ";\n  display: flex;\n  flex-direction: column;\n  font-weight: bold;\n  justify-content: center;\n  margin-bottom: 1rem;\n  row-gap: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var colors = ahm_ui/* theme.colors */.rS.colors;
var MetadataWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b08e41ba-0"
})(_templateObject(), function(param) {
    var isLeftAligned = param.isLeftAligned;
    return isLeftAligned ? "flex-start" : "center";
});
var MetadataTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b08e41ba-1"
})(_templateObject1(), colors.grey50);

;// CONCATENATED MODULE: ./src/client/pages/blog-detail/components/article-tags/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n  justify-content: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 31.25rem;\n  border: 2px solid ",
        ";\n  color: ",
        ";\n  font-weight: bold;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var TagWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8c1af62b-0"
})(styles_templateObject(), function(param) {
    var isLeftAligned = param.isLeftAligned;
    return isLeftAligned ? "0.5rem" : "1rem";
}, function(param) {
    var isLeftAligned = param.isLeftAligned;
    return isLeftAligned ? "flex-start" : "center";
});
var Tag = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8c1af62b-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.purple;
}, function(param) {
    var theme = param.theme;
    return theme.colors.purple;
});

;// CONCATENATED MODULE: ./src/client/pages/blog-detail/components/article-tags/index.tsx




var ArticleTags = function(param) {
    var tags = param.tags, isLeftAligned = param.isLeftAligned;
    if ((0,fp.isEmpty)(tags)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagWrapper, {
        isLeftAligned: isLeftAligned,
        children: (0,fp.map)(function(tag) {
            if (!tag) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                children: tag.name
            }, tag.name);
        }, tags)
    });
};
/* harmony default export */ var article_tags = (ArticleTags);

;// CONCATENATED MODULE: ./src/client/pages/blog-detail/utils/get-read-time/index.ts
/* eslint-disable no-underscore-dangle */ 
var WPM = 225;
var getReadTime = function(bodyRaw) {
    var wordsCombined = (0,fp.flow)((0,fp.filter)(function(block) {
        return block._type === "block";
    }), (0,fp.map)(function(block) {
        return (0,fp.map)(function(innerBlock) {
            return innerBlock.text;
        }, block.children);
    }), (0,fp.flatMap)(function(block) {
        return block;
    }), (0,fp.flatMap)((0,fp.split)(" ")), fp.compact)(bodyRaw);
    var copyLength = wordsCombined.length;
    return Math.ceil(copyLength / WPM);
};
/* harmony default export */ var get_read_time = (getReadTime);

;// CONCATENATED MODULE: ./src/client/pages/blog-detail/components/article-metadata/index.tsx







var ArticleMetadata = function(param) {
    var article = param.article, isLeftAligned = param.isLeftAligned;
    var bodyRaw = article.bodyRaw, tags = article.tags, _createdAt = article._createdAt;
    var updatedAtFormatted = _createdAt ? moment_default()(_createdAt).format("DD.MM.YY") : null;
    var readTime = get_read_time(bodyRaw);
    var readTimeFormatted = readTime > 0 ? "".concat(readTime, " min read") : null;
    var hasBothTextMetaDataTypes = updatedAtFormatted && readTimeFormatted;
    var hasMetadata = updatedAtFormatted || readTimeFormatted || tags;
    if (!hasMetadata) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MetadataWrapper, {
        isLeftAligned: isLeftAligned,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(article_tags, {
                isLeftAligned: isLeftAligned,
                tags: tags
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MetadataTextWrapper, {
                hasTags: !(0,fp.isEmpty)(tags),
                children: [
                    updatedAtFormatted,
                    " ",
                    hasBothTextMetaDataTypes && "|",
                    " ",
                    readTimeFormatted
                ]
            })
        ]
    });
};
/* harmony default export */ var article_metadata = (ArticleMetadata);


/***/ }),

/***/ 78972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_sections; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/components/faq-structured-content-block/index.tsx
var faq_structured_content_block = __webpack_require__(20194);
// EXTERNAL MODULE: ./src/client/application/scripts/product-review-widget-provider/index.tsx
var product_review_widget_provider = __webpack_require__(579);
// EXTERNAL MODULE: ./src/client/utils/browser.ts
var browser = __webpack_require__(40055);
// EXTERNAL MODULE: ./src/client/utils/get-is-server/index.ts
var get_is_server = __webpack_require__(41105);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/product-review-inline-widget-script/index.tsx
/* eslint-disable no-underscore-dangle */ 




var PRODUCT_REVIEW_IDS = {
    car: "car",
    home: "home-and-contents"
};
var DIV_ID = "#pr-rich-rating-badge-widget";
var WIDGET_TYPE = "rich-rating-badge";
var getWidgetSettings = function(productReviewId) {
    return {
        container: DIV_ID,
        identificationDetails: {
            identifier: productReviewId,
            strategy: "from-brand-external-entry-id",
            type: "single"
        }
    };
};
var loadWidget = function(windowObject, productReviewId) {
    // eslint-disable-next-line no-param-reassign
    windowObject.__productReviewCallbackQueue = windowObject.__productReviewCallbackQueue || [];
    windowObject.__productReviewCallbackQueue.push(function(ProductReview) {
        ProductReview.use(WIDGET_TYPE, getWidgetSettings(productReviewId));
    });
};
var destroyWidget = function(windowObject, productReviewId) {
    windowObject.__productReviewCallbackQueue.push(function(ProductReview) {
        ProductReview.destroy(WIDGET_TYPE, getWidgetSettings(productReviewId));
    });
};
var ProductReviewInlineWidgetScript = function(param) {
    var insuranceType = param.insuranceType;
    var ref = (0,react.useState)(false), hasRunLoad = ref[0], setHasRunLoad = ref[1];
    var isServer = (0,get_is_server/* default */.Z)();
    var hasProductReviewLoaded = (0,product_review_widget_provider/* useHasProductReviewScript */.r)().hasProductReviewLoaded;
    var productReviewIdKeys = (0,fp.keys)(PRODUCT_REVIEW_IDS);
    var windowObject = browser/* default.getWindow */.Z.getWindow();
    var productReviewId = PRODUCT_REVIEW_IDS[insuranceType];
    (0,react.useEffect)(function() {
        if (isServer || !(0,fp.includes)(insuranceType, productReviewIdKeys) || !hasProductReviewLoaded) {
            return undefined;
        }
        if (!hasRunLoad) {
            loadWidget(windowObject, productReviewId);
            setHasRunLoad(true);
        }
        return function() {
            if (hasRunLoad) {
                destroyWidget(windowObject, productReviewId);
                setHasRunLoad(false);
            }
        };
    }, [
        insuranceType,
        hasProductReviewLoaded,
        isServer,
        hasRunLoad,
        productReviewIdKeys,
        windowObject,
        productReviewId
    ]);
    return null;
};
/* harmony default export */ var product_review_inline_widget_script = (ProductReviewInlineWidgetScript);

// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/page-sections/index.tsx








var mapWithIndex = (0,uncap_fp_iterator/* default */.Z)(fp.map);
var PageSections = function(param) {
    var components = param.components, content = param.content, insuranceType = param.insuranceType;
    var sections = content === null || content === void 0 ? void 0 : content.sections;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(product_review_inline_widget_script, {
                insuranceType: insuranceType
            }),
            mapWithIndex(function(section, index) {
                var Component = components[section.type];
                if (!Component) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, section), {
                    insuranceType: insuranceType
                }), index);
            }, sections),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_structured_content_block/* default */.Z, {
                faqs: content === null || content === void 0 ? void 0 : content.faqQuestions
            })
        ]
    });
};
/* harmony default export */ var page_sections = (PageSections);


/***/ }),

/***/ 41992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ getContent; },
  "_": function() { return /* binding */ getSubPageContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./src/client/pages/insurance/constants/index.ts
var constants = __webpack_require__(19970);
;// CONCATENATED MODULE: ./src/client/pages/insurance/content/data/sub-pages/bali.ts

var data = {
    meta: {
        description: "Travelling to Bali and need travel insurance? With cover for lost luggage and medical expenses, plus add-ons like scooter insurance we’ve got you sorted.",
        title: "Travel Insurance for Bali - ahm Travel insurance"
    },
    sections: [],
    type: constants/* INSURANCE_TYPES.TRAVEL */.oK.TRAVEL
};
/* harmony default export */ var bali = (data);

// EXTERNAL MODULE: ./src/client/pages/insurance/content/sections/index.ts
var sections = __webpack_require__(58699);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
;// CONCATENATED MODULE: ./src/client/pages/insurance/content/data/images/car-offer-strip.svg
/* harmony default export */ var car_offer_strip = ({"src":"/_next/static/media/car-offer-strip.8e188bb7.svg","height":85,"width":122});
;// CONCATENATED MODULE: ./src/client/images/claim-tile.svg
/* harmony default export */ var claim_tile = ({"src":"/_next/static/media/claim-tile.3791cf34.svg","height":240,"width":288});
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/get-common-questions-url/index.ts

var COMMON_QUESTIONS_URL = {
    car: ahm_constants/* default.URLS.HELP.CAR_INSURANCE_COMMON_QUESTIONS */.Z.URLS.HELP.CAR_INSURANCE_COMMON_QUESTIONS,
    home: ahm_constants/* default.URLS.HELP.HOME_INSURANCE_COMMON_QUESTIONS */.Z.URLS.HELP.HOME_INSURANCE_COMMON_QUESTIONS,
    travel: ahm_constants/* default.URLS.HELP.TRAVEL_INSURANCE_COMMON_QUESTIONS */.Z.URLS.HELP.TRAVEL_INSURANCE_COMMON_QUESTIONS
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getCommonQuestionsUrl = function(insuranceType) {
    return COMMON_QUESTIONS_URL === null || COMMON_QUESTIONS_URL === void 0 ? void 0 : COMMON_QUESTIONS_URL[insuranceType];
};
/* harmony default export */ var get_common_questions_url = (getCommonQuestionsUrl);

;// CONCATENATED MODULE: ./src/client/images/help-tile.svg
/* harmony default export */ var help_tile = ({"src":"/_next/static/media/help-tile.bb1d68b4.svg","height":240,"width":239});
// EXTERNAL MODULE: ./src/client/utils/insert-footnote-reference/index.ts
var insert_footnote_reference = __webpack_require__(74537);
;// CONCATENATED MODULE: ./src/client/pages/insurance/content/data/car.ts









var COVERAGE_FEATURES = {
    COLLISION_DAMAGE: "collision-damage",
    FIRE_DAMAGE: "fire-damage",
    FIXED_KILOMETRE_PLAN: "fixed-kilometre-plan",
    MALICIOUS_ACT_DAMAGE: "malicious-act-damage",
    NATURAL_EVENT_DAMAGE: "natural-event-damage",
    PROPERTY_DAMAGE: "property-damage",
    THEFT: "theft"
};
var roadsideInclusion = "Essential roadside assistance to get you back on the road.\n\nThis is a separate service provided to you by Digicall Assist. Read the Roadside Assistance [Terms & Conditions](https://help.ahm.com.au/hc/en-us/articles/360001775316)";
/* harmony default export */ var car = ({
    meta: {
        description: "Fast and easy car insurance that gets you moving right away. You’ll also save up to 15% as an ahm or Medibank health member. T&Cs apply.",
        title: "Car insurance"
    },
    sections: [
        {
            type: sections/* CONTENT_SECTIONS.HEADER */.i.HEADER
        },
        {
            type: sections/* CONTENT_SECTIONS.PROMOTIONS */.i.PROMOTIONS
        },
        {
            footnote: {
                linkId: "footnote-1",
                reference: "1"
            },
            image: {
                alt: "car keys",
                src: car_offer_strip.src
            },
            title: "ahm and Medibank health members get up to 15% off!",
            type: sections/* CONTENT_SECTIONS.OFFER_STRIP */.i.OFFER_STRIP
        },
        {
            type: sections/* CONTENT_SECTIONS.VALUE_PROPOSITIONS */.i.VALUE_PROPOSITIONS
        },
        {
            cta: {
                name: "Start a quote",
                url: "".concat(ahm_constants/* default.URLS.SALES.CAR_INSURANCE */.Z.URLS.SALES.CAR_INSURANCE, "/quote")
            },
            footnote: {
                linkId: "footnote-2",
                reference: "2"
            },
            groups: [
                {
                    addons: [
                        {
                            description: roadsideInclusion,
                            title: "Roadside assistance"
                        },
                        {
                            description: "Cover if your vehicle is damaged or lost as a result of theft, attempted theft or fire.",
                            title: "Fire and theft cover"
                        }, 
                    ],
                    contentTitle: "Third party property cover",
                    description: "Covers damage your car might cause to another person’s car or property.",
                    id: "third-party-cover",
                    inclusions: [
                        {
                            description: "You can choose to opt for a higher excess and reduce your premiums.",
                            title: "Flexi-excess"
                        },
                        {
                            description: "We’ll pay up to $20 million if your car damages someone else’s vehicle or property.",
                            title: "Up to $20m liability cover"
                        },
                        {
                            description: "Call us any time. We’re always here to help you stay safe and organise your car to be towed, no matter the time.",
                            title: "24/7 emergency help"
                        },
                        {
                            description: "Cover up to $3,000 if your vehicle is damaged by an uninsured driver at fault who you can identify.",
                            title: "Damage by uninsured drivers"
                        }, 
                    ],
                    tabTitle: "Third party property"
                },
                {
                    addons: [
                        {
                            callout: "Cheaper!",
                            description: "Simple cover for when you don’t spend too much time behind the wheel.",
                            title: "Pay As You Drive Cover"
                        },
                        {
                            description: roadsideInclusion,
                            title: "Roadside assistance"
                        },
                        {
                            description: "We’ll help with the bill for a hire car if your claim for theft or damage is covered.",
                            title: "Hire car"
                        },
                        {
                            description: "We’ll repair or replace your car, excess-free, for your first animal collision claim each year.",
                            title: "Kanga cover"
                        },
                        {
                            description: "Up to $3,000 to cover your sports gear while it’s in, or on, your car. Cover terms apply.",
                            title: "Sports gear cover"
                        },
                        {
                            description: "We’ll repair or replace your windscreen, excess-free, once every 12 months.",
                            title: "Excess-free windscreen"
                        }, 
                    ],
                    contentTitle: "Comprehensive cover",
                    description: "Protection for your car, and cover in case you damage someone else’s car or property.",
                    id: "comprehensive-cover",
                    inclusions: [
                        {
                            description: "You can choose to opt for a higher excess and reduce your premiums.",
                            title: "Flexi-excess"
                        },
                        {
                            description: "We’ll pay up to $20 million if your car damages someone else’s vehicle or property.",
                            title: "Up to $20m liability cover"
                        },
                        {
                            description: "Call us any time. We’re always here to help you stay safe and organise your car to be towed, no matter the time.",
                            title: "24/7 emergency help"
                        },
                        {
                            description: "Cover for trailers, caravans, personal property, child safety seats and more.",
                            title: "Additional benefits"
                        },
                        {
                            description: "Cover for damage or loss caused by theft, attempted theft, collision, malicious damage, fire, and natural events.",
                            title: "Theft and damage cover"
                        },
                        {
                            description: "We’ll replace your car with a new car of the same value if it’s under 2 years old, has been written off and you’re the first registered owner.",
                            title: "New for old car replacement"
                        }, 
                    ],
                    tabTitle: "Comprehensive"
                },
                {
                    contentTitle: "Compare cover",
                    covers: [
                        {
                            features: [
                                {
                                    id: COVERAGE_FEATURES.PROPERTY_DAMAGE,
                                    inclusionState: constants/* COVERAGE_INCLUSION.INCLUDED */.Tb.INCLUDED
                                },
                                {
                                    id: COVERAGE_FEATURES.COLLISION_DAMAGE,
                                    inclusionState: constants/* COVERAGE_INCLUSION.EXCLUDED */.Tb.EXCLUDED
                                },
                                {
                                    id: COVERAGE_FEATURES.NATURAL_EVENT_DAMAGE,
                                    inclusionState: constants/* COVERAGE_INCLUSION.EXCLUDED */.Tb.EXCLUDED
                                },
                                {
                                    id: COVERAGE_FEATURES.MALICIOUS_ACT_DAMAGE,
                                    inclusionState: constants/* COVERAGE_INCLUSION.EXCLUDED */.Tb.EXCLUDED
                                },
                                {
                                    id: COVERAGE_FEATURES.THEFT,
                                    inclusionState: constants/* COVERAGE_INCLUSION.OPTIONAL */.Tb.OPTIONAL
                                },
                                {
                                    id: COVERAGE_FEATURES.FIRE_DAMAGE,
                                    inclusionState: constants/* COVERAGE_INCLUSION.OPTIONAL */.Tb.OPTIONAL
                                },
                                {
                                    id: COVERAGE_FEATURES.FIXED_KILOMETRE_PLAN,
                                    inclusionState: constants/* COVERAGE_INCLUSION.EXCLUDED */.Tb.EXCLUDED
                                }, 
                            ],
                            id: "third-party-cover",
                            name: "Third party property"
                        },
                        {
                            features: [
                                {
                                    id: COVERAGE_FEATURES.PROPERTY_DAMAGE,
                                    inclusionState: constants/* COVERAGE_INCLUSION.INCLUDED */.Tb.INCLUDED
                                },
                                {
                                    id: COVERAGE_FEATURES.COLLISION_DAMAGE,
                                    inclusionState: constants/* COVERAGE_INCLUSION.INCLUDED */.Tb.INCLUDED
                                },
                                {
                                    id: COVERAGE_FEATURES.NATURAL_EVENT_DAMAGE,
                                    inclusionState: constants/* COVERAGE_INCLUSION.INCLUDED */.Tb.INCLUDED
                                },
                                {
                                    id: COVERAGE_FEATURES.MALICIOUS_ACT_DAMAGE,
                                    inclusionState: constants/* COVERAGE_INCLUSION.INCLUDED */.Tb.INCLUDED
                                },
                                {
                                    id: COVERAGE_FEATURES.THEFT,
                                    inclusionState: constants/* COVERAGE_INCLUSION.INCLUDED */.Tb.INCLUDED
                                },
                                {
                                    id: COVERAGE_FEATURES.FIRE_DAMAGE,
                                    inclusionState: constants/* COVERAGE_INCLUSION.INCLUDED */.Tb.INCLUDED
                                },
                                {
                                    id: COVERAGE_FEATURES.FIXED_KILOMETRE_PLAN,
                                    inclusionState: constants/* COVERAGE_INCLUSION.OPTIONAL */.Tb.OPTIONAL
                                }, 
                            ],
                            id: "comprehensive-cover",
                            name: "Comprehensive"
                        }, 
                    ],
                    features: [
                        {
                            id: COVERAGE_FEATURES.PROPERTY_DAMAGE,
                            name: "You cause damage to another person’s property"
                        },
                        {
                            id: COVERAGE_FEATURES.COLLISION_DAMAGE,
                            name: "Your vehicle suffers loss or damage as a result of a collision"
                        },
                        {
                            id: COVERAGE_FEATURES.NATURAL_EVENT_DAMAGE,
                            name: "Your vehicle suffers loss or damage as a result of a natural event"
                        },
                        {
                            id: COVERAGE_FEATURES.MALICIOUS_ACT_DAMAGE,
                            name: "Your vehicle suffers loss or damage as a result of a malicious act"
                        },
                        {
                            id: COVERAGE_FEATURES.THEFT,
                            name: "Your vehicle is damaged or lost as a result of theft"
                        },
                        {
                            id: COVERAGE_FEATURES.FIRE_DAMAGE,
                            name: "Your vehicle suffers loss or damage as a result of fire"
                        },
                        {
                            id: COVERAGE_FEATURES.FIXED_KILOMETRE_PLAN,
                            name: "Pay As You Drive Cover"
                        }, 
                    ],
                    id: "compare",
                    tabTitle: "Compare cover"
                }, 
            ],
            title: "Choose cover that works for you",
            type: sections/* CONTENT_SECTIONS.INCLUSIONS */.i.INCLUSIONS
        },
        {
            tiles: [
                [
                    {
                        ctas: [
                            {
                                name: "Make a claim",
                                url: "".concat(ahm_constants/* default.URLS.SALES.CAR_INSURANCE */.Z.URLS.SALES.CAR_INSURANCE, "/login")
                            }, 
                        ],
                        footnote: {
                            linkId: "footnote-3",
                            reference: "3"
                        },
                        image: {
                            alt: "hands exchanging claim form for money",
                            src: claim_tile.src
                        },
                        subtitle: (0,insert_footnote_reference/* default */.Z)({
                            footnote: {
                                reference: "3"
                            },
                            text: "Most claims can be lodged online 24/7".concat(insert_footnote_reference/* FOOTNOTE_PLACEHOLDER */.h, ". In some cases you’ll even get a decision within minutes.")
                        }),
                        title: "Easy claiming 24/7",
                        variant: ui.TILE_VARIANTS.VERTICAL_CENTER
                    },
                    {
                        ctas: [
                            {
                                name: "More on car insurance",
                                url: get_common_questions_url("car")
                            }, 
                        ],
                        image: {
                            alt: "man screaming for help",
                            src: help_tile.src
                        },
                        subtitle: "Find out more about our car insurance product, how to make a claim and how to manage your policy.",
                        title: "Need a quick answer?",
                        variant: ui.TILE_VARIANTS.VERTICAL_CENTER
                    }, 
                ], 
            ],
            type: sections/* CONTENT_SECTIONS.TILES */.i.TILES
        },
        {
            type: sections/* CONTENT_SECTIONS.COMMON_QUESTIONS */.i.COMMON_QUESTIONS
        },
        {
            type: sections/* CONTENT_SECTIONS.QUICK_LINKS */.i.QUICK_LINKS
        },
        {
            type: sections/* CONTENT_SECTIONS.TERMS_AND_CONDITIONS */.i.TERMS_AND_CONDITIONS
        }, 
    ],
    type: "car"
});

;// CONCATENATED MODULE: ./src/client/pages/insurance/content/data/images/home-offer-strip.svg
/* harmony default export */ var home_offer_strip = ({"src":"/_next/static/media/home-offer-strip.b5614e38.svg","height":85,"width":154});
;// CONCATENATED MODULE: ./src/client/pages/insurance/content/data/home.ts









var EMERGENCY_HOME_ASSIST = {
    description: "This is a separate service provided to you by Allianz Global Assistance. Read the Emergency Home Assist [T&Cs](".concat(ahm_constants/* default.URLS.HELP.HOME_INSURANCE_FORMS_AND_GUIDES */.Z.URLS.HELP.HOME_INSURANCE_FORMS_AND_GUIDES, ")."),
    title: "Emergency Home Assist"
};
var commonInclusions = function() {
    var includePortables = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return (0,fp.compact)([
        {
            title: "Escape of liquid"
        },
        {
            title: "Riot, civil commotion or industrial unrest"
        },
        {
            title: "Earthquake, tsunami or volcanic eruption"
        },
        {
            title: "Fire, explosion or lightning"
        },
        {
            title: "Accidental glass breakage"
        },
        {
            title: "Storm and rainwater"
        },
        {
            title: "Flood"
        },
        {
            title: "Impact"
        },
        {
            title: "Theft"
        },
        {
            title: "Malicious damage"
        },
        {
            callout: "comprehensive only",
            title: "Accidental damage"
        },
        includePortables && {
            callout: "optional",
            title: "Portable valuables cover across Australia"
        }, 
    ]);
};
var homeOnlyBenefits = [
    {
        title: "Emergency accommodation"
    },
    {
        title: "Replacement locks"
    },
    {
        title: "Damage to landscaping"
    }, 
];
var contentsOnlyBenefits = [
    {
        title: "Visitor contents"
    },
    {
        title: "Contents in the open air at home"
    },
    {
        title: "Credit cards"
    }, 
];
var homeAndContentsBenefits = (0,fp.concat)([
    {
        title: "Environmental benefits"
    },
    {
        title: "Damage to landscaping"
    },
    {
        title: "Emergency accommodation"
    }, 
], contentsOnlyBenefits);
var home_data = {
    meta: {
        description: "Home and Contents insurance made simple. ahm has a range of affordable home and contents policies to suit your needs.",
        title: "Home and contents insurance"
    },
    sections: [
        {
            type: sections/* CONTENT_SECTIONS.HEADER */.i.HEADER
        },
        {
            type: sections/* CONTENT_SECTIONS.PROMOTIONS */.i.PROMOTIONS
        },
        {
            footnote: {
                linkId: "footnote-1",
                reference: "1"
            },
            image: {
                alt: "piggy bank savings",
                src: home_offer_strip.src
            },
            title: "ahm and Medibank health members get up to 30% off!",
            type: sections/* CONTENT_SECTIONS.OFFER_STRIP */.i.OFFER_STRIP
        },
        {
            type: sections/* CONTENT_SECTIONS.VALUE_PROPOSITIONS */.i.VALUE_PROPOSITIONS
        },
        {
            cta: {
                name: "Start a quote",
                url: "".concat(ahm_constants/* default.URLS.SALES.HOME_INSURANCE */.Z.URLS.SALES.HOME_INSURANCE, "/quote")
            },
            footnote: {
                linkId: "footnote-2",
                reference: "2"
            },
            groups: [
                {
                    addons: [
                        EMERGENCY_HOME_ASSIST
                    ],
                    benefits: homeOnlyBenefits,
                    contentTitle: "Home only cover",
                    description: "What it says on the tin. This cover is for home owners needing protection for their house rather than the stuff inside. Plus, you’ll also get 10% off as an ahm or Medibank health member".concat(insert_footnote_reference/* FOOTNOTE_PLACEHOLDER */.h, "."),
                    descriptionFootnote: {
                        linkId: "footnote-1",
                        reference: "1"
                    },
                    inclusions: commonInclusions(),
                    tabTitle: "Home only cover"
                },
                {
                    addons: [
                        EMERGENCY_HOME_ASSIST
                    ],
                    benefits: homeAndContentsBenefits,
                    contentTitle: "Home and contents cover",
                    description: "For home owners who need protection for their house and their stuff too. Plus, you’ll also get 10% off as an ahm or Medibank health member".concat(insert_footnote_reference/* FOOTNOTE_PLACEHOLDER */.h, "."),
                    descriptionFootnote: {
                        linkId: "footnote-1",
                        reference: "1"
                    },
                    inclusions: commonInclusions(true),
                    tabTitle: "Home and contents cover"
                },
                {
                    addons: [
                        EMERGENCY_HOME_ASSIST
                    ],
                    benefits: contentsOnlyBenefits,
                    contentTitle: "Contents only cover",
                    description: "For people who just need cover for their stuff. Plus, you’ll also get up 10% off as an ahm or Medibank health member".concat(insert_footnote_reference/* FOOTNOTE_PLACEHOLDER */.h, "."),
                    descriptionFootnote: {
                        linkId: "footnote-1",
                        reference: "1"
                    },
                    inclusions: commonInclusions(true),
                    tabTitle: "Contents only cover"
                }, 
            ],
            title: "Choose cover that works for you",
            type: sections/* CONTENT_SECTIONS.INCLUSIONS */.i.INCLUSIONS
        },
        {
            tiles: [
                [
                    {
                        ctas: [
                            {
                                name: "Make a claim",
                                url: "".concat(ahm_constants/* default.URLS.SALES.HOME_INSURANCE */.Z.URLS.SALES.HOME_INSURANCE, "/login")
                            }, 
                        ],
                        footnote: {
                            linkId: "footnote-4",
                            reference: "4"
                        },
                        image: {
                            alt: 'sign saing "Open 24/7 claims"',
                            src: claim_tile.src
                        },
                        subtitle: (0,insert_footnote_reference/* default */.Z)({
                            footnote: {
                                reference: "4"
                            },
                            text: "Most claims can be lodged online 24/7".concat(insert_footnote_reference/* FOOTNOTE_PLACEHOLDER */.h, ". In some cases, you’ll even get a decision within minutes.")
                        }),
                        title: "Easy claiming 24/7",
                        variant: ui.TILE_VARIANTS.VERTICAL_CENTER
                    },
                    {
                        ctas: [
                            {
                                name: "More on home & contents insurance",
                                url: get_common_questions_url("home")
                            }, 
                        ],
                        image: {
                            alt: "man screaming for help",
                            src: help_tile.src
                        },
                        subtitle: "Find out more about our home and contents insurance product, how to make a claim and how to manage your policy.",
                        title: "Need a quick answer?",
                        variant: ui.TILE_VARIANTS.VERTICAL_CENTER
                    }, 
                ], 
            ],
            type: sections/* CONTENT_SECTIONS.TILES */.i.TILES
        },
        {
            type: sections/* CONTENT_SECTIONS.COMMON_QUESTIONS */.i.COMMON_QUESTIONS
        },
        {
            type: sections/* CONTENT_SECTIONS.QUICK_LINKS */.i.QUICK_LINKS
        },
        {
            type: sections/* CONTENT_SECTIONS.TERMS_AND_CONDITIONS */.i.TERMS_AND_CONDITIONS
        }, 
    ],
    type: "home"
};
/* harmony default export */ var home = (home_data);

;// CONCATENATED MODULE: ./src/client/pages/insurance/content/data/sub-pages/new-zealand.ts

var new_zealand_data = {
    meta: {
        description: "Need travel insurance for your New Zealand trip? Get coverage for cancellations, surprise medical expenses, ski cover and more with ahm. Get a quote today!",
        title: "New Zealand Travel Insurance - ahm Travel insurance"
    },
    sections: [],
    type: constants/* INSURANCE_TYPES.TRAVEL */.oK.TRAVEL
};
/* harmony default export */ var new_zealand = (new_zealand_data);

;// CONCATENATED MODULE: ./src/client/pages/insurance/content/data/travel.ts


var travel_data = {
    sections: [
        {
            type: sections/* CONTENT_SECTIONS.POPULAR_DESTINATIONS */.i.POPULAR_DESTINATIONS
        }, 
    ],
    type: constants/* INSURANCE_TYPES.TRAVEL */.oK.TRAVEL
};
/* harmony default export */ var travel = (travel_data);

;// CONCATENATED MODULE: ./src/client/pages/insurance/content/index.ts








var CONTENT = {
    car: car,
    home: home,
    travel: travel
};
var _obj;
var SUB_PAGE_CONTENT = {
    travel: (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* INSURANCE_SUB_TYPES.BALI */.Ez.BALI, bali), (0,_define_property/* default */.Z)(_obj, constants/* INSURANCE_SUB_TYPES.NEW_ZEALAND */.Ez.NEW_ZEALAND, new_zealand), _obj)
};
var getContent = function(insuranceType) {
    return CONTENT[insuranceType];
};
var getSubPageContent = function(insuranceType, productOptionValue) {
    var parentInsuranceTypeContent = getContent(insuranceType);
    var subPageParentObject = SUB_PAGE_CONTENT[insuranceType];
    var subPageContent = subPageParentObject[productOptionValue];
    return (0,fp.merge)(parentInsuranceTypeContent, subPageContent);
};


/***/ }),

/***/ 86377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ insurance; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/pages/insurance/content/sections/index.ts
var sections = __webpack_require__(58699);
// EXTERNAL MODULE: ./src/client/pages/insurance/constants/index.ts
var constants = __webpack_require__(19970);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/client/components/sections/features-section/index.tsx + 3 modules
var features_section = __webpack_require__(84244);
;// CONCATENATED MODULE: ./src/client/components/sections/add-ons-section/index.tsx






var AddOnsSection = function(param) {
    var content = param.content;
    if ((0,fp.isEmpty)(content)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(features_section/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, content), {
        withBorder: true,
        withSimpleBit: false
    }));
};
/* harmony default export */ var add_ons_section = (AddOnsSection);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/sections/articles-section/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  flex-direction: column;\n  gap: 2rem;\n\n  ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin: auto;\n    max-width: 52rem;\n  }\n\n  ",
        " {\n    max-width: 60rem;\n  }\n\n  ",
        " {\n    max-width: 75rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var media = ahm_ui/* theme.media */.rS.media, mediaQueries = ahm_ui/* theme.mediaQueries */.rS.mediaQueries;
var ArticleTileContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d7a44a14-0"
})(_templateObject(), mediaQueries.above(media.sm), mediaQueries.above(media.lg));
var InnerContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d7a44a14-1"
})(_templateObject1(), mediaQueries.above(media.sm), mediaQueries.above(media.md), mediaQueries.above(media.lg));

// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/content/utils/portable-text-to-plain/index.js
var portable_text_to_plain = __webpack_require__(64355);
var portable_text_to_plain_default = /*#__PURE__*/__webpack_require__.n(portable_text_to_plain);
;// CONCATENATED MODULE: ./src/client/components/sections/articles-section/components/article-tile/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 2rem;\n  width: 100%;\n\n  ",
        " {\n    max-height: 37.75rem;\n    max-width: 23.5rem;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  aspect-ratio: auto;\n  margin-bottom: 1rem;\n  object-fit: contain;\n  width: 100%;\n  height: 11.25rem;\n  \n  ",
        " {\n    height: 7.5rem;\n    width 18.75rem;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var colors = ahm_ui/* theme.colors */.rS.colors, styles_media = ahm_ui/* theme.media */.rS.media, styles_mediaQueries = ahm_ui/* theme.mediaQueries */.rS.mediaQueries;
var ArticleTileWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b7203b89-0"
})(styles_templateObject(), colors.grey20, styles_mediaQueries.above(styles_media.lg));
var StyledImage = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-b7203b89-1"
})(styles_templateObject1(), styles_mediaQueries.above(styles_media.lg));
var HeadingWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b7203b89-2"
})(_templateObject2());

// EXTERNAL MODULE: ./src/client/pages/blog-detail/components/article-metadata/index.tsx + 4 modules
var article_metadata = __webpack_require__(96709);
;// CONCATENATED MODULE: ./src/client/components/sections/articles-section/components/article-tile/utils/create-limited-blurb/index.ts
var createLimitedBlurb = function(text, limit) {
    if (text.length <= limit) {
        return text;
    }
    return "".concat(text.slice(0, limit), "...");
};
/* harmony default export */ var create_limited_blurb = (createLimitedBlurb);

// EXTERNAL MODULE: ./src/client/cms/utils/get-image-attributes/index.ts
var get_image_attributes = __webpack_require__(51413);
;// CONCATENATED MODULE: ./src/client/components/sections/articles-section/components/article-tile/index.tsx









var BLUR_CHARACTER_LIMIT = 110;
var ArticleTile = function(param) {
    var article = param.article, insuranceType = param.insuranceType;
    var identifier = article.identifier, imageObject = article.imageObject, name = article.name, descriptionRaw = article.descriptionRaw;
    var descriptionPlainText = portable_text_to_plain_default()(descriptionRaw);
    var blurb = create_limited_blurb(descriptionPlainText, BLUR_CHARACTER_LIMIT);
    var slug = identifier === null || identifier === void 0 ? void 0 : identifier.current;
    var url = "/".concat(insuranceType, "-insurance/articles/").concat(slug);
    var imageAttributes = (0,get_image_attributes/* default */.Z)({
        imageObject: imageObject,
        width: 400
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleTileWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, (0,_object_spread/* default */.Z)({}, imageAttributes)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                            variant: "marginBottomSpacer10",
                            looksLike: "h4",
                            children: name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(article_metadata/* default */.Z, {
                        isLeftAligned: true,
                        article: article
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                        variant: "marginBottomSpacer10",
                        children: blurb
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                to: url,
                variant: [
                    "white",
                    "wide",
                    "border"
                ],
                children: "Read article"
            })
        ]
    });
};
/* harmony default export */ var article_tile = (ArticleTile);

// EXTERNAL MODULE: ./src/client/components/sections/wrapped-section/index.tsx
var wrapped_section = __webpack_require__(51878);
;// CONCATENATED MODULE: ./src/client/components/sections/articles-section/index.tsx







var ArticlesSection = function(param) {
    var articles = param.articles, insuranceType = param.insuranceType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(wrapped_section/* default */.Z, {
        withBorder: true,
        withWide: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                    looksLike: "h3",
                    variant: [
                        "marginBottomSpacer6",
                        "center"
                    ],
                    children: "Articles that might interest you"
                }),
                !(0,fp.isEmpty)(articles) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleTileContainer, {
                    children: (0,fp.map)(function(article) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_tile, {
                            article: article,
                            insuranceType: insuranceType
                        }, article.name);
                    }, articles)
                })
            ]
        })
    });
};
/* harmony default export */ var articles_section = (ArticlesSection);

// EXTERNAL MODULE: ./src/client/pages/insurance/components/award/index.tsx + 1 modules
var award = __webpack_require__(87902);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/common-questions/index.tsx
var common_questions = __webpack_require__(60333);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/contact-details/index.tsx + 2 modules
var contact_details = __webpack_require__(76701);
;// CONCATENATED MODULE: ./src/client/components/sections/core-benefits-section/benefit-item/styles.ts

function benefit_item_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  ",
        " {\n    width: 35rem;\n  }\n"
    ]);
    benefit_item_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function benefit_item_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  ",
        " {\n    width: 35rem;\n  }\n"
    ]);
    benefit_item_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n  margin: 5rem 0;\n\n  ",
        " {\n    flex-direction: ",
        ";\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 50%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var benefit_item_styles_media = ahm_ui/* theme.media */.rS.media, benefit_item_styles_mediaQueries = ahm_ui/* theme.mediaQueries */.rS.mediaQueries;
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f137d590-0"
})(benefit_item_styles_templateObject(), benefit_item_styles_mediaQueries.above(benefit_item_styles_media.lg));
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f137d590-1"
})(benefit_item_styles_templateObject1(), benefit_item_styles_mediaQueries.above(benefit_item_styles_media.lg));
var ItemWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f137d590-2"
})(styles_templateObject2(), benefit_item_styles_mediaQueries.above(benefit_item_styles_media.lg), function(param) {
    var isReverse = param.isReverse;
    return isReverse ? "row-reverse" : "row";
});
var StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-f137d590-3"
})(_templateObject3(), benefit_item_styles_mediaQueries.above(benefit_item_styles_media.lg));

;// CONCATENATED MODULE: ./src/client/components/sections/core-benefits-section/benefit-item/index.tsx





var BenefitItem = function(param) {
    var cta = param.cta, description = param.description, image = param.image, isReverse = param.isReverse, title = param.title;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ItemWrapper, {
        isReverse: isReverse,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                        variant: "marginBottomSpacer9",
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                        variant: "marginBottomSpacer9",
                        children: description
                    }),
                    (cta === null || cta === void 0 ? void 0 : cta.to) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        to: cta.to,
                        variant: [
                            "border",
                            "white"
                        ],
                        children: cta.title
                    })
                ]
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, (0,_object_spread/* default */.Z)({}, image))
            })
        ]
    });
};
/* harmony default export */ var benefit_item = (BenefitItem);

// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/components/sections/core-benefits-section/index.tsx



function core_benefits_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    padding: 2.5rem 6.5rem;\n  }\n"
    ]);
    core_benefits_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function core_benefits_section_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 2rem;\n  text-align: center;\n"
    ]);
    core_benefits_section_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var core_benefits_section_media = ahm_ui/* theme.media */.rS.media, core_benefits_section_mediaQueries = ahm_ui/* theme.mediaQueries */.rS.mediaQueries;
var core_benefits_section_ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-96928bb7-0"
})(core_benefits_section_templateObject(), core_benefits_section_mediaQueries.above(core_benefits_section_media.lg));
var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-96928bb7-1"
})(core_benefits_section_templateObject1());
var CoreBenefitsSection = function(param) {
    var content = param.content, insuranceType = param.insuranceType;
    if ((0,fp.isEmpty)(content)) {
        return null;
    }
    var benefits = content.benefits, slogan = content.slogan;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(core_benefits_section_ContentWrapper, {
                children: [
                    (insuranceType || slogan) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                        children: [
                            insuranceType && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                children: "Benefits of our ".concat((0,fp.capitalize)(insuranceType), " insurance")
                            }),
                            slogan && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                children: slogan
                            })
                        ]
                    }),
                    (0,uncap_fp_iterator/* default */.Z)(fp.map)(function(benefit, index) {
                        var isEven = index % 2 === 1;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(benefit_item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, benefit), {
                            isReverse: isEven
                        }));
                    }, benefits)
                ]
            })
        })
    });
};
/* harmony default export */ var core_benefits_section = (CoreBenefitsSection);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/cover-inclusions/index.tsx


function cover_inclusions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  @media (min-width: ",
        ") {\n    max-width: 23.5rem;\n  }\n"
    ]);
    cover_inclusions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cover_inclusions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  max-width: 62rem;\n  padding: 0 1rem;\n  @media (min-width: ",
        ") {\n    padding: 0;\n  }\n"
    ]);
    cover_inclusions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function cover_inclusions_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & li > div {\n    padding-bottom: 0.5rem;\n  }\n"
    ]);
    cover_inclusions_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var MEDIUM_SIZE_THRESHOLD = "46rem";
var INCLUSIONS_PER_ROW = 2;
var cover_inclusions_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-b1703dbd-0"
})(cover_inclusions_templateObject(), function(props) {
    return props.theme.media.md;
});
var StyledSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-b1703dbd-1"
})(cover_inclusions_templateObject1(), function(props) {
    return props.theme.media.md;
});
var StyledIconList = (0,styled_components_browser_esm["default"])(ahm_ui/* IconList */.Zd).withConfig({
    componentId: "sc-b1703dbd-2"
})(cover_inclusions_templateObject2());
var ComprehensiveCover = function(param) {
    var title = param.title, inclusionSections = param.inclusionSections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            padding: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
                variant: [
                    "paddingTopSpacer2",
                    "paddingBottomSpacer2"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                        variant: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                            variant: "marginBottomSpacer4",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
                        variant: "marginTopSpacer3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* AxisSwitcher */.e$, {
                                space: "2rem",
                                limit: INCLUSIONS_PER_ROW,
                                threshold: MEDIUM_SIZE_THRESHOLD,
                                children: (0,fp.map)(function(param) {
                                    var sectionTitle = param.title, inclusions = param.inclusions;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                                                looksLike: "h4",
                                                variant: "marginBottomSpacer9",
                                                children: sectionTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconList, {
                                                items: (0,_to_consumable_array/* default */.Z)((0,fp.map)(function(inclusion) {
                                                    return {
                                                        fill: ahm_ui/* theme.colors.green */.rS.colors.green,
                                                        icon: "tick-circle",
                                                        text: inclusion.title
                                                    };
                                                }, inclusions)).concat([
                                                    {
                                                        text: "+ Plus heaps more"
                                                    }, 
                                                ]),
                                                variant: "simple"
                                            })
                                        ]
                                    }, sectionTitle);
                                }, inclusionSections)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                                variant: [
                                    "center",
                                    "marginTopSpacer4"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cover_inclusions_StyledButton, {
                                    to: ahm_constants/* default.URLS.THIRD_PARTY.TRAVEL_INSURANCE_EXTERNAL */.Z.URLS.THIRD_PARTY.TRAVEL_INSURANCE_EXTERNAL,
                                    children: "Get a quote"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var cover_inclusions = (ComprehensiveCover);

;// CONCATENATED MODULE: ./src/client/components/sections/cross-sell-section/styles.ts

function cross_sell_section_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  row-gap: 1rem;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(3, 1fr);\n  }\n"
    ]);
    cross_sell_section_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cross_sell_section_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: none;\n\n  @media (min-width: ",
        ") {\n    width: 26rem;\n  }\n\n  & > img {\n    height: 200px;\n  }\n\n  & > div {\n    min-height: unset;\n  }\n\n  & > p {\n    margin-bottom: 2rem;\n    min-height: 3rem;\n  }\n"
    ]);
    cross_sell_section_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function cross_sell_section_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0 2rem;\n\n  @media (min-width: ",
        ") {\n    margin: 0 1rem;\n  }\n"
    ]);
    cross_sell_section_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var cross_sell_section_styles_media = ahm_ui/* theme.media */.rS.media;
var ItemsWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-eccd82b6-0"
})(cross_sell_section_styles_templateObject(), cross_sell_section_styles_media.md);
var StyledPerkTile = (0,styled_components_browser_esm["default"])(ahm_ui/* PerkTile */.P7).withConfig({
    componentId: "sc-eccd82b6-1"
})(cross_sell_section_styles_templateObject1(), cross_sell_section_styles_media.xl);
var TileWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-eccd82b6-2"
})(cross_sell_section_styles_templateObject2(), cross_sell_section_styles_media.md);

;// CONCATENATED MODULE: ./src/client/components/sections/cross-sell-section/index.tsx








var mapWithIndex = (0,uncap_fp_iterator/* default */.Z)(fp.map);
var CrossSellSection = function(param) {
    var content = param.content, insuranceType = param.insuranceType;
    if ((0,fp.isEmpty)(content)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrapped_section/* default */.Z, {
        withBorder: true,
        withWide: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.H2, {
                variant: [
                    "center",
                    "marginBottomSpacer8"
                ],
                children: [
                    "Looking for more than ",
                    insuranceType,
                    " insurance?"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsWrapper, {
                children: mapWithIndex(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TileWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPerkTile, (0,_object_spread/* default */.Z)({}, item))
                    }, index);
                }, content)
            })
        ]
    });
};
/* harmony default export */ var cross_sell_section = (CrossSellSection);

// EXTERNAL MODULE: ./src/client/pages/insurance/components/inclusions/section/feature-highlight/index.tsx
var feature_highlight = __webpack_require__(67764);
// EXTERNAL MODULE: ./src/client/utils/ui.ts
var ui = __webpack_require__(85500);
;// CONCATENATED MODULE: ./src/client/components/footnote-link/index.tsx

function footnote_link_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: 0.325rem;\n  font-size: 0.75rem;\n  padding-left: 0.25rem;\n  position: relative;\n  text-decoration: none;\n"
    ]);
    footnote_link_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var onClickFootnoteLink = function(footnoteSymbol) {
    return function() {
        (0,ui/* scrollToElement */.kI)(document.getElementById("footnote-".concat(footnoteSymbol)));
    };
};
var StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-4d700176-0"
})(footnote_link_templateObject());
var FootnoteLink = function(param) {
    var footnoteSymbol = param.footnoteSymbol;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClickable, {
        onClick: onClickFootnoteLink(footnoteSymbol),
        children: footnoteSymbol
    });
};
/* harmony default export */ var footnote_link = (FootnoteLink);

;// CONCATENATED MODULE: ./src/client/pages/insurance/components/features-and-benefits/features-or-benefits-section/index.tsx

function features_or_benefits_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .icon {\n    margin-top: 0.625rem;\n  }\n"
    ]);
    features_or_benefits_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var TYPE_PROPS = {
    addons: {
        icon: "plus",
        title: "Add ons",
        type: "partial"
    },
    benefits: {
        icon: "tick",
        title: "Additional benefits",
        type: "included"
    },
    inclusions: {
        icon: "tick",
        title: "What’s included",
        type: "included"
    }
};
var StyledIconLockup = (0,styled_components_browser_esm["default"])(ahm_ui/* IconLockup */.hp).withConfig({
    componentId: "sc-5ebda337-0"
})(features_or_benefits_section_templateObject());
var markSerializers = {
    // @ts-expect-error - Automatic, Please fix when editing this file
    footnote: function(param) {
        var mark = param.mark, children = param.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footnote_link, {
                    footnoteSymbol: mark.footnoteSymbol
                })
            ]
        });
    }
};
var FeaturesOrBenefitsSection = function(param) {
    var items = param.items, type = param.type;
    if ((0,fp.isEmpty)(items)) {
        return null;
    }
    var ref = TYPE_PROPS[type] || {}, title = ref.title, icon = ref.icon, iconType = ref.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
        variant: "marginTopSpacer7",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H4, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                children: (0,fp.map)(function(param) {
                    var callout = param.callout, descriptionRaw = param.descriptionRaw, footnoteLinkSymbol = param.footnoteLinkSymbol, itemTitle = param.title;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: 4,
                        sm: 6,
                        xs: 12,
                        variant: "marginTopSpacer10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIconLockup, {
                            icon: {
                                className: "icon",
                                name: "".concat(icon, "-circle"),
                                size: "small",
                                type: iconType
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.H5, {
                                    children: [
                                        itemTitle,
                                        footnoteLinkSymbol && /*#__PURE__*/ (0,jsx_runtime.jsx)(footnote_link, {
                                            footnoteSymbol: footnoteLinkSymbol
                                        }),
                                        callout && [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(feature_highlight/* default */.Z, {
                                                text: callout
                                            }, callout)
                                        ]
                                    ]
                                }),
                                descriptionRaw && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                                    markSerializers: markSerializers,
                                    source: descriptionRaw
                                })
                            ]
                        })
                    }, itemTitle);
                }, items)
            })
        ]
    });
};
/* harmony default export */ var features_or_benefits_section = (FeaturesOrBenefitsSection);

// EXTERNAL MODULE: ./src/client/pages/insurance/styles.module.sass
var styles_module = __webpack_require__(34604);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/features-and-benefits/index.tsx






function FeaturesAndBenefits(param) {
    var whatsIncluded = param.whatsIncluded, _addOns = param.addOns, addOns = _addOns === void 0 ? [] : _addOns, urlObject = param.urlObject;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).horizontalSpacingWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
                        variant: [
                            "paddingTopSpacer3",
                            "paddingBottomSpacer9"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                                variant: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                    variant: "marginBottomSpacer4",
                                    children: "Features and Benefits"
                                })
                            }),
                            !(0,fp.isEmpty)(whatsIncluded) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(features_or_benefits_section, {
                                items: whatsIncluded,
                                type: "inclusions"
                            }) : null,
                            !(0,fp.isEmpty)(addOns) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(features_or_benefits_section, {
                                items: addOns,
                                type: "addons"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                        variant: [
                            "paddingTopSpacer6",
                            "paddingBottomSpacer6"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                            variant: "center",
                            children: (urlObject === null || urlObject === void 0 ? void 0 : urlObject.url) && (urlObject === null || urlObject === void 0 ? void 0 : urlObject.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                                to: urlObject.url,
                                children: urlObject.name
                            })
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var features_and_benefits = (FeaturesAndBenefits);

;// CONCATENATED MODULE: ./src/client/pages/insurance/components/forms-and-guides/index.tsx

function forms_and_guides_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin: 3rem 0;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    margin: 1rem 6rem;\n  }\n"
    ]);
    forms_and_guides_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function forms_and_guides_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  margin: 1rem;\n\n  @media (min-width: ",
        ") {\n    width: 25%;\n  }\n\n  @media (min-width: ",
        ") {\n    width: 20%;\n  }\n"
    ]);
    forms_and_guides_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function forms_and_guides_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n\n  > span {\n    height: 100%;\n  }\n"
    ]);
    forms_and_guides_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Flex = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-73fef39d-0"
})(forms_and_guides_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var StyledButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-73fef39d-1"
})(forms_and_guides_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(param) {
    var theme = param.theme;
    return theme.media.lg;
});
var forms_and_guides_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-73fef39d-2"
})(forms_and_guides_templateObject2());
var icon = {
    name: "chevron-right",
    position: "right",
    size: "extraSmall"
};
// @ts-expect-error - Automatic, Please fix when editing this file
var FormsAndGuides = function(param) {
    var documents = param.documents, heading = param.heading, urlObject = param.urlObject;
    if ((0,fp.isEmpty)(documents)) {
        return null;
    }
    var documentsToShow = (0,fp.take)(4, documents);
    var url = urlObject === null || urlObject === void 0 ? void 0 : urlObject.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        hideBorderTop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            padding: "1rem",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
                variant: [
                    "marginBottomSpacer2",
                    "marginTopSpacer2"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                        variant: [
                            "center"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.H2, {
                            children: [
                                heading || "Forms and guides",
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                        children: (0,fp.map)(function(param) {
                            var label = param.label, file = param.file, key = param.key;
                            var ref, ref1;
                            if ((0,fp.isEmpty)(file) || (0,fp.isNil)(file === null || file === void 0 ? void 0 : (ref = file.asset) === null || ref === void 0 ? void 0 : ref.url)) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_and_guides_StyledButton, {
                                    analytics: {
                                        label: label
                                    },
                                    icon: {
                                        name: "arrow-down",
                                        position: "right"
                                    },
                                    to: file === null || file === void 0 ? void 0 : (ref1 = file.asset) === null || ref1 === void 0 ? void 0 : ref1.url,
                                    variant: [
                                        "border",
                                        "transparentBlack",
                                        "wide"
                                    ],
                                    height: "100%",
                                    inNewTab: true,
                                    children: label
                                })
                            }, key);
                        }, documentsToShow)
                    }),
                    !(0,fp.isNil)(url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                        variant: [
                            "center"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                            icon: icon,
                            to: url,
                            children: urlObject === null || urlObject === void 0 ? void 0 : urlObject.name
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var forms_and_guides = (FormsAndGuides);

// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/inclusions/index.tsx + 5 modules
var inclusions = __webpack_require__(63147);
// EXTERNAL MODULE: ./src/client/components/sections/information-section/index.tsx + 3 modules
var information_section = __webpack_require__(51435);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/icons-web/lib/index.js
var lib = __webpack_require__(54312);
// EXTERNAL MODULE: ./src/client/components/sections/accordion-section/index.tsx + 4 modules
var accordion_section = __webpack_require__(64323);
;// CONCATENATED MODULE: ./src/client/components/sections/item-section/item-card/styles.ts

function item_card_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    item_card_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function item_card_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 0.5rem 0 0.5rem 1rem;\n"
    ]);
    item_card_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function item_card_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: ",
        ";\n\n  @media (min-width: ",
        ") {\n    height: fit-content;\n    margin: 0 auto;\n    max-width: 21.25rem;\n    flex-shrink: 1;\n    flex-grow: 1;\n    flex-basis: 21.25rem;\n  }\n"
    ]);
    item_card_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " 1rem 2.5rem 1rem;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 1rem 0;\n\n  & > section {\n    padding: unset;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & button > p {\n    align-items: flex-start;\n    padding-left: 0;\n  }\n\n  & button > p > svg {\n    margin-left: 1.5rem;\n    min-width: 1rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1rem;\n  max-width: 154px;\n  padding: 1.125rem 1rem;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var border = ahm_ui/* theme.border */.rS.border, styles_colors = ahm_ui/* theme.colors */.rS.colors, item_card_styles_media = ahm_ui/* theme.media */.rS.media;
var BestSellerTag = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-839605c7-0"
})(item_card_styles_templateObject(), styles_colors.white);
var BestSellerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-839605c7-1"
})(item_card_styles_templateObject1(), styles_colors.purple);
var CardWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-839605c7-2"
})(item_card_styles_templateObject2(), function(param) {
    var isBestSeller = param.isBestSeller;
    return isBestSeller ? "1px solid ".concat(styles_colors.purple) : "".concat(border.greyBorder);
}, item_card_styles_media.md);
var DetailsWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-839605c7-3"
})(styles_templateObject3(), function(param) {
    var isBestSeller = param.isBestSeller;
    return isBestSeller ? "1rem" : "2.5rem";
});
var ServiceWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-839605c7-4"
})(_templateObject4());
var StyledAccordionSection = (0,styled_components_browser_esm["default"])(accordion_section/* default */.Z).withConfig({
    componentId: "sc-839605c7-5"
})(_templateObject5());
var styles_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-839605c7-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/client/components/sections/item-section/item-card/index.tsx







var item_card_colors = ahm_ui/* theme.colors */.rS.colors;
var ItemCard = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, descriptionRaw = param.descriptionRaw, identifier = param.identifier, index = param.index, isBestSeller = param.isBestSeller, name = param.name, includedServices = param.includedServices, urlObject = param.urlObject;
    var formattedServices = (0,fp.map)(function(service) {
        var serviceDescription = service.descriptionRaw, title = service.name;
        return {
            body: portable_text_to_plain_default()(serviceDescription),
            title: title
        };
    }, includedServices);
    var itemsWithIcons = (0,fp.map)(// @ts-ignore - Automatic, Please fix when editing this file
    function(item) {
        return (0,fp.set)("title", /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                maxWidth: "15rem"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], {
                        fill: item_card_colors.green,
                        name: "tick-circle"
                    })
                }),
                item.title
            ]
        }), item);
    }, formattedServices);
    var accordionId = identifier === null || identifier === void 0 ? void 0 : identifier.current;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, {
        className: className,
        index: index,
        isBestSeller: isBestSeller,
        "aria-label": ariaLabel,
        children: [
            isBestSeller && /*#__PURE__*/ (0,jsx_runtime.jsx)(BestSellerWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BestSellerTag, {
                    variant: "simpleBit",
                    children: "Our best seller!"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsWrapper, {
                isBestSeller: isBestSeller,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H4, {
                        variant: "marginBottomSpacer10",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                        variant: "marginBottomSpacer8",
                        children: portable_text_to_plain_default()(descriptionRaw)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                variant: [
                                    "marginBottomSpacer11",
                                    "bold"
                                ],
                                children: "What’s included"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAccordionSection, {
                                accordionId: "".concat(accordionId, "-accordion"),
                                // @ts-ignore - Automatic, Please fix when editing this file
                                items: itemsWithIcons,
                                minimalBorder: true,
                                spacerSize: "None",
                                ariaLabelPrefix: ariaLabel
                            })
                        ]
                    }),
                    urlObject && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledButton, {
                        to: urlObject.url,
                        children: urlObject.name
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var item_card = (ItemCard);

;// CONCATENATED MODULE: ./src/client/components/sections/item-section/styles.ts

function item_section_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n  justify-content: space-between;\n  margin-top: 2rem;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    item_section_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function item_section_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    order: ",
        ";\n  }\n"
    ]);
    item_section_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function item_section_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  [role='tablist'] {\n    max-width: 35rem;\n  }\n"
    ]);
    item_section_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function item_section_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1100px;\n  margin: 0 auto;\n"
    ]);
    item_section_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var item_section_styles_media = ahm_ui/* theme.media */.rS.media;
var styles_ItemsWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-318386db-0"
})(item_section_styles_templateObject(), item_section_styles_media.md);
var StyledItemCard = (0,styled_components_browser_esm["default"])(item_card).withConfig({
    componentId: "sc-318386db-1"
})(item_section_styles_templateObject1(), item_section_styles_media.md, function(param) {
    var isBestSeller = param.isBestSeller, index = param.index;
    return isBestSeller ? 2 : "".concat(index);
});
var StyledTabGroup = (0,styled_components_browser_esm["default"])(ahm_ui/* TabGroup */.v0).withConfig({
    componentId: "sc-318386db-2"
})(item_section_styles_templateObject2());
var styles_ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-318386db-3"
})(item_section_styles_templateObject3());

;// CONCATENATED MODULE: ./src/client/components/sections/item-section/index.tsx










var mapUncapped = (0,uncap_fp_iterator/* default */.Z)(fp.map);
var ItemSection = function(param) {
    var content = param.content, title = param.title;
    var ref = (0,react.useState)(null), tabValue = ref[0], setTabValue = ref[1];
    // Ensure we only take two item groups
    var itemGroups = (0,fp.take)(2, content);
    var defaultTabGroup = (0,fp.head)(itemGroups);
    var displayTab = (0,fp.size)(itemGroups) > 1;
    (0,react.useEffect)(function() {
        if (defaultTabGroup) {
            setTabValue(defaultTabGroup.productType);
        }
    }, [
        defaultTabGroup,
        defaultTabGroup === null || defaultTabGroup === void 0 ? void 0 : defaultTabGroup.productType
    ]);
    if ((0,fp.isEmpty)(content)) {
        return null;
    }
    var itemPanels = (0,fp.map)(function(item) {
        return {
            panel: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ItemsWrapper, {
                children: mapUncapped(function(product, index) {
                    /*#__PURE__*/ return (0,react.createElement)(StyledItemCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                        ariaLabel: product.name,
                        index: index,
                        key: index,
                        includedServices: product === null || product === void 0 ? void 0 : product.includedServices
                    }));
                }, (0,fp.sortBy)(function(product) {
                    return (product === null || product === void 0 ? void 0 : product.isBestSeller) !== true;
                }, item.products))
            }),
            text: (0,fp.upperFirst)(item === null || item === void 0 ? void 0 : item.productType),
            value: item === null || item === void 0 ? void 0 : item.productType
        };
    }, itemGroups);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(wrapped_section/* default */.Z, {
        withWide: true,
        withBorder: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ContentWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                    variant: [
                        "center",
                        "marginBottomSpacer8"
                    ],
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabGroup, {
                    displayTab: displayTab,
                    input: {
                        onChange: setTabValue,
                        value: tabValue
                    },
                    options: itemPanels
                })
            ]
        })
    });
};
/* harmony default export */ var item_section = (ItemSection);

// EXTERNAL MODULE: ./src/client/pages/insurance/components/page-sections/index.tsx + 1 modules
var page_sections = __webpack_require__(78972);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/popular-destinations-section/images/bali-beach.svg
/* harmony default export */ var bali_beach = ({"src":"/_next/static/media/bali-beach.cd9d5ac6.svg","height":221,"width":474});
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/popular-destinations-section/images/nz-mountains.svg
/* harmony default export */ var nz_mountains = ({"src":"/_next/static/media/nz-mountains.e163cc57.svg","height":227,"width":564});
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/popular-destinations-section/data.ts


var data = [
    {
        cta: {
            name: "Find out more about Bali Travel Insurance",
            url: "/travel-insurance/bali"
        },
        description: "Bali is one of the most beloved destinations for Aussie travellers. ahm has a range of travel insurance cover options to suit your Bali getaway.",
        imageObject: {
            caption: "Bali beach",
            image: {
                asset: {
                    _id: "bali-image",
                    url: bali_beach.src
                }
            }
        },
        title: "Bali"
    },
    {
        cta: {
            name: "Find out more about New Zealand Travel Insurance",
            url: "/travel-insurance/new-zealand"
        },
        description: "Whether you’re planning a summer getaway or a winter break, ahm has travel insurance for your New Zealand trip.",
        imageObject: {
            caption: "New Zealand mountains",
            image: {
                asset: {
                    _id: "nz-image",
                    url: nz_mountains.src
                }
            }
        },
        title: "New Zealand"
    }, 
];
/* harmony default export */ var popular_destinations_section_data = (data);

;// CONCATENATED MODULE: ./src/client/pages/insurance/components/popular-destinations-section/components/destination-tile/styles.ts

function destination_tile_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  padding: 2rem 1rem;\n\n  @media (min-width: ",
        ") {\n    padding: 2rem;\n  }\n}\n"
    ]);
    destination_tile_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function destination_tile_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  max-height: 12rem;\n"
    ]);
    destination_tile_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function destination_tile_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  text-decoration-offset: 3px;\n"
    ]);
    destination_tile_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function destination_tile_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 500px;\n"
    ]);
    destination_tile_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  max-width: 600px;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var destination_tile_styles_colors = ahm_ui/* theme.colors */.rS.colors, destination_tile_styles_media = ahm_ui/* theme.media */.rS.media;
var BodyWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2e2ced6b-0"
})(destination_tile_styles_templateObject(), destination_tile_styles_colors.grey20, destination_tile_styles_media.sm);
var styles_ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2e2ced6b-1"
})(destination_tile_styles_templateObject1());
var styles_StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-2e2ced6b-2"
})(destination_tile_styles_templateObject2());
var StyledDescription = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-2e2ced6b-3"
})(destination_tile_styles_templateObject3());
var styles_StyledImage = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-2e2ced6b-4"
})(styles_templateObject4());
var styles_TileWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2e2ced6b-5"
})(styles_templateObject5(), destination_tile_styles_colors.grey20);

;// CONCATENATED MODULE: ./src/client/pages/insurance/components/popular-destinations-section/components/destination-tile/index.tsx




var DestinationTile = function(param) {
    var cta = param.cta, description = param.description, imageObject = param.imageObject, title = param.title;
    var ref, ref1;
    var imageUrl = imageObject === null || imageObject === void 0 ? void 0 : (ref = imageObject.image) === null || ref === void 0 ? void 0 : (ref1 = ref.asset) === null || ref1 === void 0 ? void 0 : ref1.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_TileWrapper, {
        children: [
            imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledImage, {
                    alt: imageObject.caption,
                    src: imageUrl
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyWrapper, {
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescription, {
                        children: description
                    }),
                    cta && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledClickable, {
                        to: cta.url,
                        children: cta.name
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var destination_tile = (DestinationTile);

;// CONCATENATED MODULE: ./src/client/pages/insurance/components/popular-destinations-section/index.tsx


function popular_destinations_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  max-width: 600px;\n"
    ]);
    popular_destinations_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function popular_destinations_section_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  gap: 2rem;\n  flex-direction: column;\n\n  @media (min-width: ",
        ") {\n    align-items: normal;\n    flex-direction: row;\n    justify-content: center;\n  }\n"
    ]);
    popular_destinations_section_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var popular_destinations_section_media = ahm_ui/* theme.media */.rS.media;
var Subtitle = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-31f8443e-0"
})(popular_destinations_section_templateObject());
var popular_destinations_section_TileWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-31f8443e-1"
})(popular_destinations_section_templateObject1(), popular_destinations_section_media.md);
var PopularDestinationsSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrapped_section/* default */.Z, {
        withBorder: true,
        withWide: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                variant: "center",
                children: "Popular destinations"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                variant: [
                    "center",
                    "marginBottomSpacer8"
                ],
                children: "We know how much Aussies love flocking overseas, so we’ve simplified your travel insurance search with some of ahm customers’ favourite destinations."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popular_destinations_section_TileWrapper, {
                children: (0,uncap_fp_iterator/* default */.Z)(fp.map)(function(destination, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(destination_tile, (0,_object_spread/* default */.Z)({}, destination), index);
                }, popular_destinations_section_data)
            })
        ]
    });
};
/* harmony default export */ var popular_destinations_section = (PopularDestinationsSection);

;// CONCATENATED MODULE: ./src/client/pages/insurance/components/promotions/styles.ts

function promotions_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2rem;\n"
    ]);
    promotions_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function promotions_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    display: grid;\n    grid-template-columns: 1fr 6fr;\n  }\n"
    ]);
    promotions_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function promotions_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  max-width: 50rem;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1rem;\n  grid-column-start: 2;\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    promotions_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function promotions_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n"
    ]);
    promotions_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function promotions_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 73px;\n  height: 35px;\n  @media (min-width: ",
        ") {\n    width: 97px;\n    height: 46px;\n  }\n"
    ]);
    promotions_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledGridBox = (0,styled_components_browser_esm["default"])(ahm_ui/* GridBox */.zc).withConfig({
    componentId: "sc-5a027b17-0"
})(promotions_styles_templateObject());
var OuterContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5a027b17-1"
})(promotions_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var Container = (0,styled_components_browser_esm["default"])(ahm_ui/* SpacerWrapper */.Cj).withConfig({
    componentId: "sc-5a027b17-2"
})(promotions_styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var FlexContainerColumn = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5a027b17-3"
})(promotions_styles_templateObject3());
var promotions_styles_StyledImage = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-5a027b17-4"
})(promotions_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
});

// EXTERNAL MODULE: ./src/client/components/offers/images/offer-tag.svg
var offer_tag = __webpack_require__(9788);
;// CONCATENATED MODULE: ./src/client/pages/insurance/components/promotions/index.tsx






var Promotions = function(param) {
    var promotions = param.promotions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,fp.map)(function(promotion) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridBox, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OuterContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(promotions_styles_StyledImage, {
                                    src: offer_tag/* default.src */.Z.src,
                                    alt: "Offer"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexContainerColumn, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                            looksLike: "h4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                                                source: promotion.name
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                                            source: promotion.description
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            });
        }, promotions)
    });
};
/* harmony default export */ var promotions = (Promotions);

// EXTERNAL MODULE: ./src/client/components/quick-links/index.tsx + 1 modules
var quick_links = __webpack_require__(83697);
// EXTERNAL MODULE: ./src/client/utils/get-footnote-serializer/index.tsx
var get_footnote_serializer = __webpack_require__(50073);
// EXTERNAL MODULE: ./src/client/utils/insert-footnote-reference/index.ts
var insert_footnote_reference = __webpack_require__(74537);
;// CONCATENATED MODULE: ./src/client/components/sections/strip-section/index.tsx

function strip_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n\n  .footnote {\n    bottom: 1rem;\n    font-family: ",
        ";\n    font-size: 1.5rem;\n    padding-left: 0.5rem;\n    position: relative;\n    text-decoration: none;\n\n    &:hover {\n      textdecoration: underline;\n    }\n  }\n"
    ]);
    strip_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function strip_section_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex: 1 1 auto;\n  justify-content: center;\n  text-align: center;\n  padding: 2rem 0;\n\n  &.hasImage {\n    padding: 1rem;\n  }\n"
    ]);
    strip_section_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function strip_section_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  text-align: center;\n"
    ]);
    strip_section_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var StyledContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5a7e1c40-0"
})(strip_section_templateObject(), function(param) {
    var theme = param.theme;
    return theme.fontFamilies.base;
});
var StyledH2 = (0,styled_components_browser_esm["default"])(ahm_ui.H2).withConfig({
    componentId: "sc-5a7e1c40-1"
})(strip_section_templateObject1());
var StyledImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5a7e1c40-2"
})(strip_section_templateObject2());
var StripSection = function(param) {
    var footnote = param.footnote, image = param.image, title = param.title;
    var hasImage = image === null || image === void 0 ? void 0 : image.src;
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(wrapped_section/* default */.Z, {
        withBorder: true,
        withInvert: true,
        withWide: true,
        variant: [
            "paddingTopSpacer10",
            "paddingBottomSpacer10"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH2, {
                    looksLike: "h3",
                    variant: [
                        "simpleBit",
                        "regular",
                        hasImage && "hasImage"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                        source: (0,insert_footnote_reference/* default */.Z)({
                            footnote: footnote,
                            text: title
                        }),
                        typeSerializers: (0,get_footnote_serializer/* default */.Z)({
                            footnote: footnote,
                            variant: "footnote"
                        })
                    })
                }),
                hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                        src: image.src,
                        alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : ""
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var strip_section = (StripSection);

// EXTERNAL MODULE: ./src/client/pages/insurance/components/terms-and-conditions/index.tsx
var terms_and_conditions = __webpack_require__(59297);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/styles.tsx

function header_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  @media (min-width: ",
        ") {\n    display: block;\n    position: absolute;\n    top: 14.25rem;\n    left: 41.75rem;\n  }\n"
    ]);
    header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n    position: absolute;\n    z-index: 1;\n    top: 6.5rem;\n    left: 25rem;\n  }\n\n  ",
        " {\n    left: 27.25rem;\n  }\n"
    ]);
    header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 6rem 1rem;\n\n  ",
        " {\n    padding: 6rem 2.5rem;\n  }\n"
    ]);
    header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1.5rem;\n  ",
        " {\n    margin-bottom: 0;\n    max-width: 36rem;\n  }\n"
    ]);
    header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 31.25rem;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 0;\n"
    ]);
    header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    header_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  ",
        " {\n    flex-direction: row;\n    gap: 2rem;\n    padding: 0 1.5rem;\n  }\n\n  ",
        " {\n    padding: 0;\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var header_styles_mediaQueries = ahm_ui/* theme.mediaQueries */.rS.mediaQueries, header_styles_media = ahm_ui/* theme.media */.rS.media;
var OfferTongueWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1aa01327-0"
})(header_styles_templateObject(), function(param) {
    var displayOffer = param.displayOffer;
    return displayOffer ? "block" : "none";
}, header_styles_media.md);
var PlaneVideoWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1aa01327-1"
})(header_styles_templateObject1(), header_styles_mediaQueries.above(header_styles_media.lg), header_styles_mediaQueries.above(header_styles_media.xl));
var header_styles_ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1aa01327-2"
})(header_styles_templateObject2(), header_styles_mediaQueries.above(header_styles_media.lg));
var SubtitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1aa01327-3"
})(header_styles_templateObject3(), header_styles_mediaQueries.above(header_styles_media.md));
var OverflowWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1aa01327-4"
})(header_styles_templateObject4());
var HeaderWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1aa01327-5"
})(header_styles_templateObject5());
var TitleSection = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1aa01327-6"
})(styles_templateObject6(), ahm_ui/* theme.mediaQueries.above */.rS.mediaQueries.above(ahm_ui/* theme.media.md */.rS.media.md), ahm_ui/* theme.mediaQueries.above */.rS.mediaQueries.above(ahm_ui/* theme.media.lg */.rS.media.lg));
var styles_TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1aa01327-7"
})(_templateObject7());

// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ahm_constants_ui = __webpack_require__(93590);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/hooks/travel-widget-context/index.tsx


var TravelWidgetContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var TravelWidgetProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)([]), countries = ref[0], setCountries = ref[1];
    var ref1 = (0,react.useState)(0), travellerCount = ref1[0], setTravellerCount = ref1[1];
    var ref2 = (0,react.useState)({
        from: undefined,
        to: undefined
    }), selected = ref2[0], setSelected = ref2[1];
    var ref3 = (0,react.useState)(null), currentWidgetErrors = ref3[0], setCurrentWidgetErrors = ref3[1];
    var value = react.useMemo(function() {
        return {
            countries: countries,
            currentWidgetErrors: currentWidgetErrors,
            selected: selected,
            setCountries: setCountries,
            setCurrentWidgetErrors: setCurrentWidgetErrors,
            setSelected: setSelected,
            setTravellerCount: setTravellerCount,
            travellerCount: travellerCount
        };
    }, [
        countries,
        setCountries,
        selected,
        setSelected,
        setTravellerCount,
        travellerCount,
        currentWidgetErrors,
        setCurrentWidgetErrors, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelWidgetContext.Provider, {
        value: value,
        children: children
    });
};


;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/awards/images/mozo-award.svg
/* harmony default export */ var mozo_award = ({"src":"/_next/static/media/mozo-award.b2d744ba.svg","height":85,"width":167});
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/awards/images/we-money-award.svg
/* harmony default export */ var we_money_award = ({"src":"/_next/static/media/we-money-award.f005b517.svg","height":95,"width":95});
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/awards/index.tsx

function awards_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin-top: 3rem;\n\n  ",
        " {\n    align-items: flex-start;\n    padding-left: 1.5rem;\n  }\n\n  ",
        " {\n    padding: 0;\n    margin-top: 1rem;\n  }\n"
    ]);
    awards_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function awards_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin-bottom: 1rem;\n"
    ]);
    awards_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var awards_media = ahm_ui/* theme.media */.rS.media, awards_mediaQueries = ahm_ui/* theme.mediaQueries */.rS.mediaQueries;
var AwardsWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c4892f17-0"
})(awards_templateObject(), awards_mediaQueries.above(awards_media.md), awards_mediaQueries.above(awards_media.lg));
var ImagesWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c4892f17-1"
})(awards_templateObject1());
var Awards = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AwardsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImagesWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                        src: we_money_award.src,
                        alt: "WeMoney award"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                        src: mozo_award.src,
                        alt: "Mozo award"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H4, {
                variant: [
                    "center",
                    "simpleBit"
                ],
                children: "ahm’s travel insurance is award winning!"
            })
        ]
    });
};
/* harmony default export */ var awards = (Awards);

// EXTERNAL MODULE: ./src/client/utils/device.ts
var device = __webpack_require__(49814);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/styles.ts

function widget_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-right: 1.5rem;\n"
    ]);
    widget_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function widget_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border-radius: 3rem;\n  flex-direction: column;\n\n  ",
        " {\n    box-shadow: 0px 4px 7px 0px rgba(128, 128, 128, 0.2);\n    flex-direction: row;\n    width: max-content;\n  }\n\n  ",
        " {\n    width: max-content;\n  }\n"
    ]);
    widget_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function widget_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    widget_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function widget_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  padding: 1.5rem;\n"
    ]);
    widget_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function widget_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    widget_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function widget_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 85px;\n  box-shadow: 0px 4px 7px 0px rgba(128, 128, 128, 0.2);\n  display: ",
        ";\n  font-weight: unset;\n  height: 100px;\n  justify-content: space-between;\n  margin: 0 auto;\n  min-width: 300px;\n  padding: 1rem 1.5rem;\n  text-align: left;\n  width: 100%;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    widget_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function widget_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 1rem;\n  margin-top: 1rem;\n  margin-bottom: 10rem;\n  width: 100%;\n\n  ",
        " {\n    align-self: center;\n    border-radius: 4.5rem;\n    margin-left: 2rem;\n    padding: 1rem 2rem;\n    width: 14rem;\n  }\n"
    ]);
    widget_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  background-color: ",
        ";\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100dvh;\n  min-height: 100%;\n  min-width: 100dvw;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  padding: ",
        ";\n  padding-top: 0;\n  z-index: ",
        ";\n\n  ",
        " {\n    display: block;\n    min-height: unset;\n    min-width: unset;\n    width: max-content;\n    height: unset;\n    overflow: unset;\n    padding: 1.5rem;\n    padding-bottom: 2.25rem;\n    background-color: ",
        ";\n    position: relative;\n    z-index: ",
        ";\n    border-radius: 1rem;\n    max-width: 72.25rem;\n    margin-top: ",
        ";\n    margin-bottom: 3rem;\n  }\n\n  ",
        " {\n    width: unset;\n  }\n\n  ",
        " {\n    max-width: 76.75rem;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  ",
        " {\n    display: block;\n    position: absolute;\n    top: 3.25rem;\n    left: 28rem;\n  }\n\n  ",
        " {\n    left: 37.25rem;\n  }\n\n  ",
        " {\n    left: 39.5rem;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 1rem;\n\n  @media (min-width: ",
        ") {\n    position: absolute;\n    right: 1rem;\n    top: 1rem;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 1rem;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  left: 0;\n  padding: 2rem ",
        " 1rem;\n  z-index: ",
        ";\n  width: calc(100% + (",
        " * 2));\n  margin-left: -",
        ";\n\n  ",
        " {\n    width: 100%;\n    background-color: unset;\n    display: block;\n    left: unset;\n    position: unset;\n    top: unset;\n    padding: 0;\n    margin-left: 0;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1rem;\n  ",
        " {\n    margin-bottom: 1.5rem;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  ",
        " {\n    flex-grow: unset;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}


var widget_styles_colors = ahm_ui/* theme.colors */.rS.colors, widget_styles_media = ahm_ui/* theme.media */.rS.media, widget_styles_mediaQueries = ahm_ui/* theme.mediaQueries */.rS.mediaQueries, zIndices = ahm_ui/* theme.zIndices */.rS.zIndices;
var WIDGET_WRAPPER_PADDING = "1rem";
var ButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a7657341-0"
})(widget_styles_templateObject());
var FormWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a7657341-1"
})(widget_styles_templateObject1(), widget_styles_mediaQueries.above(widget_styles_media.md), widget_styles_mediaQueries.above(widget_styles_media.lg));
var styles_HeadingWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a7657341-2"
})(widget_styles_templateObject2());
var MobileButton = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a7657341-3"
})(widget_styles_templateObject3(), widget_styles_colors.purple);
var MobileToggleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a7657341-4"
})(widget_styles_templateObject4(), function(param) {
    var displayMobileToggle = param.displayMobileToggle;
    return displayMobileToggle ? "block" : "none";
}, function(param) {
    var isDestinationPage = param.isDestinationPage;
    return isDestinationPage ? "1rem" : "0";
});
var MobileToggle = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-a7657341-5"
})(widget_styles_templateObject5(), widget_styles_colors.white, function(param) {
    var displayMobileToggle = param.displayMobileToggle;
    return displayMobileToggle ? "flex" : "none";
}, widget_styles_mediaQueries.above(widget_styles_media.lg));
var widget_styles_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-a7657341-6"
})(widget_styles_templateObject6(), widget_styles_mediaQueries.above(widget_styles_media.md));
var styles_StyledH2 = (0,styled_components_browser_esm["default"])(ahm_ui.H2).withConfig({
    componentId: "sc-a7657341-7"
})(styles_templateObject7(), widget_styles_colors.black);
var StyledP = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-a7657341-8"
})(_templateObject8(), widget_styles_colors.grey30);
var WidgetWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a7657341-9"
})(_templateObject9(), function(param) {
    var displayWidget = param.displayWidget;
    return displayWidget ? "flex" : "none";
}, widget_styles_colors.white, WIDGET_WRAPPER_PADDING, zIndices.reactModal, widget_styles_mediaQueries.above(widget_styles_media.md), function(param) {
    var isActive = param.isActive;
    return isActive ? widget_styles_colors.white : "transparent";
}, function(param) {
    var isActive = param.isActive;
    return isActive ? zIndices.reactModal : 0;
}, function(param) {
    var isDestinationPage = param.isDestinationPage;
    return isDestinationPage ? "0" : "2rem";
}, widget_styles_mediaQueries.above(widget_styles_media.lg), widget_styles_mediaQueries.above(widget_styles_media.xl));
var styles_OfferTongueWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a7657341-10"
})(_templateObject10(), function(param) {
    var displayOffer = param.displayOffer;
    return displayOffer ? "block" : "none";
}, widget_styles_mediaQueries.above(widget_styles_media.md), widget_styles_mediaQueries.above(widget_styles_media.lg), widget_styles_mediaQueries.above(widget_styles_media.xl));
var CloseButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-a7657341-11"
})(_templateObject11(), widget_styles_media.md);
var BackButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-a7657341-12"
})(_templateObject12(), widget_styles_mediaQueries.above(widget_styles_media.md));
var MenuWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a7657341-13"
})(_templateObject13(), widget_styles_colors.white, WIDGET_WRAPPER_PADDING, zIndices.reactModal, WIDGET_WRAPPER_PADDING, WIDGET_WRAPPER_PADDING, widget_styles_mediaQueries.above(widget_styles_media.md));
var LabelSpacer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a7657341-14"
})(_templateObject14(), widget_styles_mediaQueries.above(widget_styles_media.md));
var MobileScrollWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a7657341-15"
})(_templateObject15(), widget_styles_mediaQueries.above(widget_styles_media.lg));
var StyledForm = (0,styled_components_browser_esm["default"])(ahm_ui/* Form */.l0).withConfig({
    componentId: "sc-a7657341-16"
})(_templateObject16());

// EXTERNAL MODULE: ./src/client/utils/browser.ts
var browser = __webpack_require__(40055);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/constants.tsx
/* eslint-disable sort-keys */ 


var FIELD_NAMES = {
    DEPARTURE_DATE: "departureDate",
    DESTINATIONS: "destinations",
    IS_MEMBER: "isMember",
    RETURN_DATE: "returnDate",
    WHEN: "when",
    WHERE: "where",
    WHO: "who",
    PROMO_CODE: "promoCode",
    RESIDENT: "resident",
    TRAVELLER_AGE_1: "travelerAge_1",
    TRAVELLER_AGE_2: "travelerAge_2",
    TRAVELLER_AGE_3: "travelerAge_3",
    TRAVELLER_AGE_4: "travelerAge_4",
    TRAVELLER_AGE_5: "travelerAge_5",
    TRAVELLER_AGE_6: "travelerAge_6",
    TRAVELLER_AGE_7: "travelerAge_7",
    TRAVELLER_AGE_8: "travelerAge_8",
    TRAVELLER_AGE_9: "travelerAge_9",
    TRAVELLER_AGE_10: "travelerAge_10"
};
var WHEN_FIELD_NAMES = [
    FIELD_NAMES.DEPARTURE_DATE,
    FIELD_NAMES.RETURN_DATE
];
var WHO_FIELD_NAMES = [
    FIELD_NAMES.PROMO_CODE,
    FIELD_NAMES.TRAVELLER_AGE_1,
    FIELD_NAMES.TRAVELLER_AGE_2,
    FIELD_NAMES.TRAVELLER_AGE_3,
    FIELD_NAMES.TRAVELLER_AGE_4,
    FIELD_NAMES.TRAVELLER_AGE_5,
    FIELD_NAMES.TRAVELLER_AGE_6,
    FIELD_NAMES.TRAVELLER_AGE_7,
    FIELD_NAMES.TRAVELLER_AGE_8,
    FIELD_NAMES.TRAVELLER_AGE_9,
    FIELD_NAMES.TRAVELLER_AGE_10,
    FIELD_NAMES.RESIDENT, 
];
var SUGGESTED_DESTINATIONS = [
    {
        label: "Indonesia (Bali)",
        value: "Indonesia (Bali)",
        code: "510-101-100"
    },
    {
        label: "The United States of America (USA)",
        value: "United States of America (USA)",
        code: "507-236-288"
    },
    {
        label: "New Zealand",
        value: "New Zealand",
        code: "1006-61"
    },
    {
        label: "Thailand",
        value: "Thailand",
        code: "509-166"
    },
    {
        label: "Europe",
        value: "Europe",
        code: "508-327"
    },
    {
        label: "Worldwide",
        value: "Worldwide",
        code: "507-322-274"
    }, 
];
var ACCORDION_ITEMS = [
    {
        title: "Spending 20% or more of your trip in the Americas or Africa?",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "If you’ll be spending 20% or more of your trip in the Americas or Africa, you must select “Worldwide” or enter and select a country of the Americas or Africa (no matter where you are going before or after)."
        })
    },
    {
        title: "Taking a cruise?",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* List */.aV, {
            variant: "inside",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "In Australia (e.g. on the Murray River) or in Australian coastal waters (e.g. a Kimberley Cruise) - Please choose or enter “Australia”"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "From a port in Australia to another port or ports in Australia without any stopover at a port outside of Australia (e.g. a ’Sampler Cruise’, a cruise from Sydney to Brisbane) - Please choose or enter “Domestic Cruise”."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Overseas (e.g. a European river cruise, Caribbean cruise or a cruise from Hong Kong to Sydney) or from a port in Australia to another port or ports outside Australia (e.g. Sydney/Singapore) - Please choose or enter the main area or destination/country based on where you will spend the most time on your trip."
                })
            ]
        })
    },
    {
        title: "Travelling to multiple countries in Europe?",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "If you are travelling to multiple countries in Europe, you can select the country you are spending the most of your time, or if you are spending your time equally across multiple different European countries you can select “Europe”."
        })
    }, 
];
// matches one or more characters not including '(', followed by a space, an opening parenthesis '(', one or more characters not including ')', and an optional closing parenthesis ')'
var PARENTHESIS_MATCH_REGEX = /^([^(]+)\s\(([^)]+)\)?$/;
var DEFAULT_DATE_FORMAT = "dd/mm/yy";
var SESSION_STORAGE_KEYS = {
    FORMIK_STATE: "travel-widget-state",
    TRAVELLER_COUNT: "travel-widget-amount-of-travellers"
};

// EXTERNAL MODULE: ./node_modules/react-day-picker/src/style.css
var style = __webpack_require__(42415);
// EXTERNAL MODULE: ./node_modules/react-day-picker/dist/esm/index.js + 157 modules
var esm = __webpack_require__(35258);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/date-picker/styles.ts

function date_picker_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  margin-top: 1.5rem;\n"
    ]);
    date_picker_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function date_picker_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1rem;\n\n  @media (min-width: ",
        ") {\n    margin-bottom: 1.5rem;\n  }\n"
    ]);
    date_picker_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function date_picker_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    max-width: 37rem;\n  }\n\n  .rdp-root {\n    --rdp-accent-color: unset;\n    --rdp-selected-border: unset;\n    --rdp-accent-background-color: unset;\n    --rdp-day_button-border: unset;\n    --rdp-day-width: 1rem;\n    --rdp-font-family: ",
        ";\n\n    display: flex;\n    justify-content: center;\n\n    @media (min-width: ",
        ") {\n      --rdp-day-height: 1rem;\n      display: unset;\n      justify-content: unset;\n      height: unset;\n    }\n  }\n  .rdp-caption_label {\n    font: 1rem ",
        ";\n    font-weight: 400;\n  }\n  .rdp-chevron {\n    margin-left: 0.5rem;\n  }\n  .rdp-day {\n    box-shadow: inset 0 0 0 ",
        " ",
        ";\n  }\n  .rdp-day_button {\n    font: 1rem ",
        ";\n    padding: 1rem;\n\n    @media (min-width: ",
        ") {\n      padding: 1.25rem;\n    }\n  }\n  .rdp-dropdowns {\n    gap: 1rem;\n  }\n  .rdp-month_caption {\n    justify-content: flex-start;\n  }\n  .rdp-months {\n    @media (min-width: ",
        ") {\n      gap: 8rem;\n    }\n    @media (min-width: ",
        ") {\n      gap: 1.5rem;\n    }\n    @media (min-width: ",
        ") {\n      gap: 2rem;\n    }\n  }\n  .rdp-nav {\n    gap: 1.5rem;\n  }\n  .rdp-weekday {\n    color: ",
        ";\n    font-size: 1rem;\n    font-weight: 400;\n    opacity: 1;\n  }\n  .rdp-selected.rdp-range_middle {\n    border-radius: 0;\n    color: inherit;\n    background-color: ",
        ";\n    box-shadow:\n      inset 0 ",
        " 0 0 ",
        ",\n      inset 0 -",
        " 0 0 ",
        ";\n\n    font-weight: unset;\n  }\n  .rdp-today {\n    box-shadow: inset 0 0 0 ",
        " ",
        ";\n    border-radius: 0.5rem;\n  }\n  .rdp-range_start,\n  .rdp-range_end,\n  .rdp-selected {\n    background-color: ",
        ";\n    border-radius: 5px;\n    box-shadow: inset 0 0 0 ",
        " ",
        ";\n    color: ",
        ";\n    font-size: 16px;\n  }\n\n  .rdp-week,\n  .rdp-weekdays {\n    background-color: ",
        ";\n  }\n\n  th,\n  td {\n    background-color: ",
        ";\n    border-bottom: unset;\n    padding: 0;\n  }\n\n  tr {\n    height: 2rem;\n  }\n  th:first-child {\n    color: ",
        ";\n    font-weight: 400;\n    font-size: unset;\n    opacity: 1;\n    text-align: center;\n  }\n  table {\n    border-collapse: separate;\n    border-spacing: 0 1rem;\n  }\n"
    ]);
    date_picker_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var date_picker_styles_colors = ahm_ui/* theme.colors */.rS.colors, fontFamilies = ahm_ui/* theme.fontFamilies */.rS.fontFamilies, date_picker_styles_media = ahm_ui/* theme.media */.rS.media;
var BORDER_THICKNESS = "1px";
var date_picker_styles_StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-cfda4ad6-0"
})(date_picker_styles_templateObject());
var StyledHeading = (0,styled_components_browser_esm["default"])(ahm_ui.H2).withConfig({
    componentId: "sc-cfda4ad6-1"
})(date_picker_styles_templateObject1(), date_picker_styles_media.md);
var StyledDayPickerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cfda4ad6-2"
})(date_picker_styles_templateObject2(), date_picker_styles_media.md, fontFamilies.base, date_picker_styles_media.md, fontFamilies.base, BORDER_THICKNESS, date_picker_styles_colors.white, fontFamilies.base, date_picker_styles_media.md, date_picker_styles_media.sm, date_picker_styles_media.md, date_picker_styles_media.lg, date_picker_styles_colors.grey50, date_picker_styles_colors.purpleTint, BORDER_THICKNESS, date_picker_styles_colors.purple, BORDER_THICKNESS, date_picker_styles_colors.purple, BORDER_THICKNESS, date_picker_styles_colors.purple, date_picker_styles_colors.purple, BORDER_THICKNESS, date_picker_styles_colors.purple, date_picker_styles_colors.white, date_picker_styles_colors.white, date_picker_styles_colors.white, date_picker_styles_colors.grey50);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/hooks/use-travel-widget-context/index.ts


var useTravelWidgetContext = function() {
    var context = (0,react.useContext)(TravelWidgetContext);
    if (context === undefined) {
        throw new Error("This hook must be used within the TravelWidgetProvider");
    }
    return context;
};
/* harmony default export */ var use_travel_widget_context = (useTravelWidgetContext);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/date-picker/index.tsx












var TWELVE_MONTHS = 12;
var ONE_MONTH = 1;
var TWO_MONTH = 2;
var DatePicker = function() {
    var ref = use_travel_widget_context(), selected = ref.selected, setSelected = ref.setSelected;
    var ref1 = (0,formik_esm.useFormikContext)(), setFieldValue = ref1.setFieldValue, values = ref1.values;
    var departureDate = values.departureDate, returnDate = values.returnDate;
    var ref2 = (0,react.useState)(false), showWarning = ref2[0], setShowWarning = ref2[1];
    (0,react.useEffect)(function() {
        if (departureDate || returnDate) {
            var parsedDepartureDate = departureDate ? moment_default()(departureDate, ahm_constants/* default.DATE_FORMAT.STANDARD */.Z.DATE_FORMAT.STANDARD).toDate() : undefined;
            var parsedReturnDate = returnDate ? moment_default()(returnDate, ahm_constants/* default.DATE_FORMAT.STANDARD */.Z.DATE_FORMAT.STANDARD).toDate() : undefined;
            setSelected({
                from: parsedDepartureDate,
                to: parsedReturnDate
            });
        }
    }, []);
    (0,react.useEffect)(function() {
        var currentDatePlusTwo = moment_default()().add(2, "days");
        var momentDepartureDate = moment_default()(departureDate, ahm_constants/* default.DATE_FORMAT.STANDARD */.Z.DATE_FORMAT.STANDARD);
        if (!momentDepartureDate.isValid()) {
            setShowWarning(false);
            return;
        }
        var isDateWithin3Days = momentDepartureDate.isSameOrBefore(currentDatePlusTwo, "day");
        setShowWarning(isDateWithin3Days);
    }, [
        departureDate,
        returnDate
    ]);
    var monthsToDisplay = device/* default.isMobile */.Z.isMobile() ? ONE_MONTH : TWO_MONTH;
    var startDate = new Date();
    var endDate = new Date().setMonth(startDate.getMonth() + TWELVE_MONTHS);
    var setSelectedDates = function(dates) {
        setSelected(dates);
        setFieldValue(FIELD_NAMES.DEPARTURE_DATE, dates.from ? moment_default()(dates.from).format(ahm_constants/* default.DATE_FORMAT.STANDARD */.Z.DATE_FORMAT.STANDARD) : null);
        setFieldValue(FIELD_NAMES.RETURN_DATE, dates.to ? moment_default()(dates.to).format(ahm_constants/* default.DATE_FORMAT.STANDARD */.Z.DATE_FORMAT.STANDARD) : null);
    };
    var clearDates = function() {
        setSelected({
            from: undefined,
            to: undefined
        });
        setFieldValue(FIELD_NAMES.DEPARTURE_DATE, "");
        setFieldValue(FIELD_NAMES.RETURN_DATE, "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDayPickerWrapper, {
        children: [
            showWarning && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Alert */.bZ, {
                heading: "Already on your trip?",
                level: "warning",
                children: "If you’ve already left home and are on your trip, this cover is subject to a 3-day no-cover period."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading, {
                looksLike: "h5",
                children: "What dates are you traveling?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DayPicker */._W, {
                defaultMonth: startDate,
                disabled: {
                    before: startDate
                },
                onSelect: setSelectedDates,
                selected: selected,
                min: ONE_MONTH,
                mode: "range",
                numberOfMonths: monthsToDisplay,
                required: true,
                startMonth: startDate,
                endMonth: new Date(endDate)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(date_picker_styles_StyledClickable, {
                onClick: clearDates,
                children: "Clear dates"
            })
        ]
    });
};
/* harmony default export */ var date_picker = (DatePicker);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/destination-suggestions/styles.tsx

function destination_suggestions_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n\n  & > section:last-of-type {\n    border-bottom: none;\n  }\n"
    ]);
    destination_suggestions_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function destination_suggestions_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n\n  & > section {\n    padding: unset;\n\n    header > button > p {\n      font-weight: normal;\n    }\n  }\n"
    ]);
    destination_suggestions_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function destination_suggestions_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1.5rem;\n  grid-template-columns: repeat(2, 1fr);\n  display: grid;\n  gap: 0.5rem;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(3, 1fr);\n  }\n"
    ]);
    destination_suggestions_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function destination_suggestions_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0.5rem;\n  text-align: center;\n\n  &:hover {\n    padding: 0 0.5rem;\n  }\n"
    ]);
    destination_suggestions_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function destination_suggestions_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    width: 34.5rem;\n  }\n"
    ]);
    destination_suggestions_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var styles_StyledAccordionSection = (0,styled_components_browser_esm["default"])(accordion_section/* default */.Z).withConfig({
    componentId: "sc-d94e1-0"
})(destination_suggestions_styles_templateObject());
var styles_ServiceWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d94e1-1"
})(destination_suggestions_styles_templateObject1());
var DestinationContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d94e1-2"
})(destination_suggestions_styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var StyledJourneyButton = (0,styled_components_browser_esm["default"])(ahm_ui/* JourneyButton */.TJ).withConfig({
    componentId: "sc-d94e1-3"
})(destination_suggestions_styles_templateObject3());
var destination_suggestions_styles_ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d94e1-4"
})(destination_suggestions_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/destination-suggestions/index.tsx









var DestinationSuggestions = function(param) {
    var autoCompleteRef = param.autoCompleteRef, setIsModalOpen = param.setIsModalOpen, setFieldTouched = param.setFieldTouched;
    var setFieldValue = (0,formik_esm.useFormikContext)().setFieldValue;
    var setPopularDestinationHandler = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(destination) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setFieldValue(FIELD_NAMES.WHERE, destination.value)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            setFieldTouched === null || setFieldTouched === void 0 ? void 0 : setFieldTouched(FIELD_NAMES.WHERE, true)
                        ];
                    case 2:
                        _state.sent();
                        setFieldValue(FIELD_NAMES.DESTINATIONS, destination.code);
                        autoCompleteRef === null || autoCompleteRef === void 0 ? void 0 : (ref = autoCompleteRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                        setIsModalOpen === null || setIsModalOpen === void 0 ? void 0 : setIsModalOpen(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(destination) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setFieldValue,
        autoCompleteRef,
        setIsModalOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(destination_suggestions_styles_ContentWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                looksLike: "h5",
                children: "Where are you travelling?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                children: "Select or search for the country where you will spend the most time."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                looksLike: "h6",
                variant: "marginBottomSpacer11",
                children: "Popular destinations"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DestinationContainer, {
                children: (0,fp.map)(function(destination) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledJourneyButton, {
                        onClick: function() {
                            return setPopularDestinationHandler(destination);
                        },
                        children: destination.label
                    }, destination.label);
                }, SUGGESTED_DESTINATIONS)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                looksLike: "h6",
                variant: "marginBottomSpacer11",
                children: "Destination FAQs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ServiceWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledAccordionSection, {
                    minimalBorder: true,
                    spacerSize: "None",
                    items: ACCORDION_ITEMS,
                    accordionId: "destination-faqs"
                })
            })
        ]
    });
};
/* harmony default export */ var destination_suggestions = (DestinationSuggestions);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/traveller-details/styles.ts

function traveller_details_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    max-width: 25rem;\n  }\n"
    ]);
    traveller_details_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function traveller_details_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    traveller_details_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function traveller_details_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0;\n  width: 12rem;\n\n  & > input {\n    border-radius: 0.25rem;\n  }\n"
    ]);
    traveller_details_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function traveller_details_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 0.25rem;\n"
    ]);
    traveller_details_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function traveller_details_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 0.5rem;\n"
    ]);
    traveller_details_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function traveller_details_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    traveller_details_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function traveller_details_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > label {\n    & > input {\n      accent-color: ",
        ";\n    }\n  }\n"
    ]);
    traveller_details_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function traveller_details_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: bold;\n"
    ]);
    traveller_details_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var traveller_details_styles_colors = ahm_ui/* theme.colors */.rS.colors, traveller_details_styles_media = ahm_ui/* theme.media */.rS.media;
var traveller_details_styles_ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2c738bc2-0"
})(traveller_details_styles_templateObject(), traveller_details_styles_media.md);
var MaxTravellerCountP = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-2c738bc2-1"
})(traveller_details_styles_templateObject1(), traveller_details_styles_colors.redDark);
var PromoField = (0,styled_components_browser_esm["default"])(ahm_ui/* FormikField */.Ub).withConfig({
    componentId: "sc-2c738bc2-2"
})(traveller_details_styles_templateObject2());
var PromoLabel = styled_components_browser_esm["default"].label.withConfig({
    componentId: "sc-2c738bc2-3"
})(traveller_details_styles_templateObject3());
var PromoLabelWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2c738bc2-4"
})(traveller_details_styles_templateObject4());
var PromoP = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-2c738bc2-5"
})(traveller_details_styles_templateObject5(), traveller_details_styles_colors.grey50);
var StyledCheckbox = (0,styled_components_browser_esm["default"])(ahm_ui/* FormikField */.Ub).withConfig({
    componentId: "sc-2c738bc2-6"
})(traveller_details_styles_templateObject6(), traveller_details_styles_colors.purple);
var traveller_details_styles_StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-2c738bc2-7"
})(traveller_details_styles_templateObject7(), traveller_details_styles_colors.redDark);

// EXTERNAL MODULE: ./src/client/utils/get-travel-insurance-constants/index.ts
var get_travel_insurance_constants = __webpack_require__(21408);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/traveller-details/components/traveller-counter/styles.ts

function traveller_counter_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: center;\n"
    ]);
    traveller_counter_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function traveller_counter_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0;\n"
    ]);
    traveller_counter_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function traveller_counter_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: ",
        " !important;\n  display: flex;\n  margin: 0 1rem;\n\n  &:focus {\n    border-radius: 3rem;\n  }\n"
    ]);
    traveller_counter_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function traveller_counter_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    traveller_counter_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function traveller_counter_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.25rem;\n  text-align: center;\n  width: 1rem;\n"
    ]);
    traveller_counter_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function traveller_counter_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n"
    ]);
    traveller_counter_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var traveller_counter_styles_colors = ahm_ui/* theme.colors */.rS.colors;
var styles_ButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-397be11a-0"
})(traveller_counter_styles_templateObject());
var Label = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-397be11a-1"
})(traveller_counter_styles_templateObject1());
var traveller_counter_styles_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-397be11a-2"
})(traveller_counter_styles_templateObject2(), function(param) {
    var disabled = param.disabled;
    return disabled ? "not-allowed" : "pointer";
});
var styles_StyledP = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-397be11a-3"
})(traveller_counter_styles_templateObject3(), traveller_counter_styles_colors.grey50);
var StyledSpan = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-397be11a-4"
})(traveller_counter_styles_templateObject4());
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-397be11a-5"
})(traveller_counter_styles_templateObject5());

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/traveller-details/components/traveller-counter/index.tsx






var traveller_counter_colors = ahm_ui/* theme.colors */.rS.colors;
var MAX_ADDITIONAL_TRAVELLERS = 9;
var ZERO_ADDITIONAL_TRAVELLERS = 0;
var TravellerCounter = function(param) {
    var travellerCount = param.travellerCount, setTravellerCount = param.setTravellerCount;
    var setFieldValue = (0,formik_esm.useFormikContext)().setFieldValue;
    var incrementTraveller = function() {
        if (travellerCount < MAX_ADDITIONAL_TRAVELLERS) {
            setTravellerCount(travellerCount + 1);
        }
    };
    var decrementTraveller = function() {
        if (travellerCount > ZERO_ADDITIONAL_TRAVELLERS) {
            var travellerCountPlusPrimary = travellerCount + 1;
            setFieldValue("travelerAge_".concat(travellerCountPlusPrimary), undefined);
            setTravellerCount(travellerCount - 1);
            setFieldValue("travelerAge_".concat(travellerCount + 1), "");
        }
    };
    var disableDecrement = travellerCount === ZERO_ADDITIONAL_TRAVELLERS;
    var disableIncrement = travellerCount === MAX_ADDITIONAL_TRAVELLERS;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        variant: "bold",
                        children: "Add additional travellers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledP, {
                        children: "Limited to 10 travellers, max 4 adults"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(traveller_counter_styles_StyledButton, {
                        "aria-label": "decrement-button",
                        disabled: disableDecrement,
                        onClick: decrementTraveller,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], {
                            fill: disableDecrement && traveller_counter_colors.grey30,
                            name: "minus-circle",
                            size: "medium"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpan, {
                        children: travellerCount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(traveller_counter_styles_StyledButton, {
                        "aria-label": "increment-button",
                        disabled: disableIncrement,
                        onClick: incrementTraveller,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], {
                            fill: disableIncrement && traveller_counter_colors.grey30,
                            name: "plus-circle",
                            size: "medium"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var traveller_counter = (TravellerCounter);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/step-input/styles.ts

function step_input_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-color: ",
        ";\n  border-radius: 1rem;\n  border-style: solid;\n  border-width: ",
        ";\n  border-bottom-left-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n  box-shadow: ",
        ";\n  margin-bottom: ",
        ";\n  padding: 1rem;\n  background-color: ",
        ";\n\n  ",
        " {\n    width: ",
        ";\n    border: unset;\n    border-radius: unset;\n    border-radius: ",
        ";\n    box-shadow: unset;\n    border-bottom-left-radius: ",
        ";\n    border-top-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n    border-top-right-radius: ",
        ";\n    display: flex;\n    margin-bottom: 0;\n    padding: 0;\n\n    &:focus {\n      border-radius: 3rem;\n      outline: 2px dotted ",
        ";\n      outline-offset: 2px;\n      z-index: 1;\n      position: relative;\n    }\n\n    ",
        "\n\n    &:hover {\n      background-color: ",
        ";\n      border-radius: 6.5rem;\n      cursor: pointer;\n    }\n  }\n  ",
        " {\n    width: ",
        ";\n  }\n\n  ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    step_input_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function step_input_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n"
    ]);
    step_input_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function step_input_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    align-self: center;\n    display: ",
        ";\n    border-right: 1px solid ",
        ";\n    height: 4rem;\n  }\n"
    ]);
    step_input_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function step_input_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 1rem;\n\n  ",
        " {\n    max-width: 14rem;\n    justify-content: normal;\n    gap: 0.5rem;\n  }\n\n  ",
        " {\n    max-width: 15.75rem;\n  }\n\n  ",
        " {\n    gap: 1rem;\n  }\n"
    ]);
    step_input_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function step_input_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 6.5rem;\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n\n  ",
        " {\n    border: ",
        ";\n    box-shadow: ",
        ";\n    width: ",
        ";\n    padding: ",
        ";\n\n    & input:focus {\n      outline: none;\n      outline-offset: none;\n    }\n  }\n"
    ]);
    step_input_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function step_input_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n"
    ]);
    step_input_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function step_input_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-style: solid;\n  border-width: 1px;\n  border-color: ",
        ";\n  border-top: none;\n  border-bottom-left-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n  box-shadow: ",
        ";\n  margin-bottom: ",
        ";\n  padding: 1rem;\n\n  ",
        " {\n    border-radius: 1rem;\n    border-color: ",
        ";\n    border-top: 1px solid ",
        ";\n    box-shadow: ",
        ";\n    margin-top: 1rem;\n    margin-bottom: 0;\n    padding: 2rem;\n    position: absolute;\n    width: max-content;\n    top: 8.25rem;\n    z-index: 100;\n    left: ",
        ";\n    right: ",
        ";\n  }\n\n  ",
        " {\n    right: unset;\n  }\n"
    ]);
    step_input_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function step_input_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 1.25rem;\n"
    ]);
    step_input_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 1rem;\n  width: 100%;\n\n  ",
        " {\n    position: absolute;\n    right: 1.25rem;\n    align-items: center;\n    border-radius: 4.5rem;\n    margin-left: 3rem;\n    padding: 0;\n    z-index: 2;\n    width: 3.25rem;\n    height: 3.25rem;\n    display: flex;\n    justify-content: center;\n    top: 0.75rem;\n    top: 18px;\n  }\n\n  ",
        " {\n    & svg {\n      margin: 0;\n    }\n  }\n\n  ",
        " {\n    top: 15px;\n    padding: 0.75rem 2rem;\n    height: auto;\n    max-width: 14rem;\n    width: auto;\n    right: 1.5rem;\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0;\n  margin-right: 1rem;\n  width: 100%;\n\n  ",
        " {\n    margin-right: 0;\n    width: auto;\n  }\n\n  & input {\n    font-size: 1.25rem;\n  }\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    width: ",
        ";\n  }\n\n  ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  color: ",
        ";\n  margin-bottom: 1.5rem;\n\n  ",
        " {\n    display: block;\n    font-size: 14px;\n    margin-bottom: 0;\n    margin-top: 0.5rem;\n    position: absolute;\n    bottom: -1.75rem;\n  }\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var step_input_styles_colors = ahm_ui/* theme.colors */.rS.colors, step_input_styles_media = ahm_ui/* theme.media */.rS.media, step_input_styles_mediaQueries = ahm_ui/* theme.mediaQueries */.rS.mediaQueries;
var DESKTOP_BORDER_RADIUS = "3rem";
var BOX_SHADOW = "0px 4px 7px 0px rgba(128, 128, 128, 0.2)";
var BORDER_WIDTH = "1px";
var PANEL_SPACING_TO_EDGE = "1.5rem";
var FieldWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cf739fe1-0"
})(step_input_styles_templateObject(), function(param) {
    var isOpen = param.isOpen, hasError = param.hasError;
    if (hasError) return step_input_styles_colors.red;
    if (isOpen) return step_input_styles_colors.purple;
    return step_input_styles_colors.grey10;
}, BORDER_WIDTH, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "0" : "";
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "0" : "";
}, BOX_SHADOW, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "0" : "1rem";
}, function(param) {
    var hasError = param.hasError;
    return hasError ? step_input_styles_colors.redTint : "transparent";
}, step_input_styles_mediaQueries.above(step_input_styles_media.md), function(param) {
    var hasButton = param.hasButton;
    return hasButton ? "21rem" : "fill-available";
}, function(param) {
    var hasError = param.hasError;
    return hasError ? "3rem" : "unset";
}, function(param) {
    var isFirst = param.isFirst;
    return isFirst ? "".concat(DESKTOP_BORDER_RADIUS) : "";
}, function(param) {
    var isFirst = param.isFirst;
    return isFirst ? "".concat(DESKTOP_BORDER_RADIUS) : "";
}, function(param) {
    var isLast = param.isLast;
    return isLast ? "".concat(DESKTOP_BORDER_RADIUS) : "";
}, function(param) {
    var isLast = param.isLast;
    return isLast ? "".concat(DESKTOP_BORDER_RADIUS) : "";
}, step_input_styles_colors.grey50, function(param) {
    var isButtonHovered = param.isButtonHovered, hasError = param.hasError;
    return isButtonHovered && "\n      background-color: ".concat(hasError ? step_input_styles_colors.redTint : step_input_styles_colors.grey10, ";\n      border-radius: 6.5rem;\n    ");
}, function(param) {
    var isOpen = param.isOpen, hasError = param.hasError;
    if (hasError) return step_input_styles_colors.redTint;
    if (isOpen) return step_input_styles_colors.white;
    return step_input_styles_colors.grey10;
}, step_input_styles_mediaQueries.above(step_input_styles_media.lg), function(param) {
    var hasButton = param.hasButton;
    return hasButton ? "31.25rem" : "fill-available";
}, step_input_styles_mediaQueries.above(step_input_styles_media.xl), function(param) {
    var hasButton = param.hasButton;
    return hasButton ? "34.25rem" : "fill-available";
});
var IconWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cf739fe1-1"
})(step_input_styles_templateObject1());
var InputSeparator = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cf739fe1-2"
})(step_input_styles_templateObject2(), step_input_styles_mediaQueries.above(step_input_styles_media.md), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "none" : "flex";
}, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? step_input_styles_colors.grey20 : step_input_styles_colors.white;
});
var InnerInputWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cf739fe1-3"
})(step_input_styles_templateObject3(), step_input_styles_mediaQueries.above(step_input_styles_media.md), step_input_styles_mediaQueries.above(step_input_styles_media.lg), step_input_styles_mediaQueries.above(step_input_styles_media.xl));
var InputWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cf739fe1-4"
})(step_input_styles_templateObject4(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "6.5rem" : "0";
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "6.5rem" : "0";
}, step_input_styles_mediaQueries.above(step_input_styles_media.md), function(param) {
    var isOpen = param.isOpen, hasError = param.hasError;
    if (hasError) return "".concat(BORDER_WIDTH, " solid ").concat(step_input_styles_colors.red);
    if (isOpen) return "".concat(BORDER_WIDTH, " solid ").concat(step_input_styles_colors.purple);
    return "unset";
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "".concat(BOX_SHADOW) : "unset";
}, function(param) {
    var hasButton = param.hasButton;
    return hasButton ? "100%" : "auto";
}, function(param) {
    var isOpen = param.isOpen, hasError = param.hasError;
    return isOpen || hasError ? "calc(1rem - ".concat(BORDER_WIDTH, ") calc(2rem - ").concat(BORDER_WIDTH, ")") : "1rem 2rem";
});
var styles_Label = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-cf739fe1-5"
})(step_input_styles_templateObject5());
var ModalWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cf739fe1-6"
})(step_input_styles_templateObject6(), step_input_styles_colors.white, function(param) {
    var isOpen = param.isOpen, hasError = param.hasError;
    if (hasError) return step_input_styles_colors.red;
    if (isOpen) return step_input_styles_colors.purple;
    return step_input_styles_colors.grey10;
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "1rem" : "0";
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "1rem" : "0";
}, BOX_SHADOW, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "1rem" : "0";
}, step_input_styles_mediaQueries.above(step_input_styles_media.md), step_input_styles_colors.purple, step_input_styles_colors.purple, BOX_SHADOW, function(param) {
    var isFirst = param.isFirst;
    return isFirst ? "-".concat(PANEL_SPACING_TO_EDGE) : "unset";
}, function(param) {
    var isLast = param.isLast;
    return isLast ? "-".concat(PANEL_SPACING_TO_EDGE) : "unset";
}, step_input_styles_mediaQueries.above(step_input_styles_media.lg));
var PlaceholderText = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-cf739fe1-7"
})(step_input_styles_templateObject7(), function(param) {
    var hasValue = param.hasValue;
    return hasValue ? step_input_styles_colors.black : step_input_styles_colors.grey40;
});
var step_input_styles_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-cf739fe1-8"
})(styles_templateObject8(), step_input_styles_mediaQueries.above(step_input_styles_media.md), step_input_styles_mediaQueries.below(step_input_styles_media.lg), step_input_styles_mediaQueries.above(step_input_styles_media.lg));
var StyledFormikField = (0,styled_components_browser_esm["default"])(ahm_ui/* FormikField */.Ub).withConfig({
    componentId: "sc-cf739fe1-9"
})(styles_templateObject9(), step_input_styles_mediaQueries.above(step_input_styles_media.md));
var ToggleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cf739fe1-10"
})(styles_templateObject10(), step_input_styles_mediaQueries.above(step_input_styles_media.md), function(param) {
    var isLast = param.isLast;
    return isLast ? "10rem" : "13rem";
}, step_input_styles_mediaQueries.above(step_input_styles_media.xl), function(param) {
    var isLast = param.isLast;
    return isLast ? "10rem" : "14rem";
});
var styles_Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cf739fe1-11"
})(styles_templateObject11(), step_input_styles_mediaQueries.above(step_input_styles_media.md));
var ErrorText = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cf739fe1-12"
})(styles_templateObject12(), step_input_styles_colors.redDark, step_input_styles_mediaQueries.above(step_input_styles_media.md));

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/traveller-details/components/traveller-field/index.tsx

function traveller_field_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    traveller_field_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function traveller_field_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 14px;\n"
    ]);
    traveller_field_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function traveller_field_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 0.25rem;\n  flex-direction: column;\n"
    ]);
    traveller_field_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function traveller_field_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0;\n  width: 8rem;\n\n  & > input {\n    border-radius: 0.25rem;\n    text-align: center;\n  }\n\n  @media (min-width: ",
        ") {\n    width: 6.25rem;\n\n    & > input {\n      text-align: unset;\n      text-indent: 1.25rem;\n    }\n  }\n"
    ]);
    traveller_field_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function traveller_field_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    bottom: unset;\n    position: relative;\n    margin-top: 0.25rem;\n  }\n"
    ]);
    traveller_field_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function traveller_field_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1rem;\n"
    ]);
    traveller_field_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var traveller_field_colors = ahm_ui/* theme.colors */.rS.colors, traveller_field_media = ahm_ui/* theme.media */.rS.media, traveller_field_mediaQueries = ahm_ui/* theme.mediaQueries */.rS.mediaQueries;
var traveller_field_Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-eabad306-0"
})(traveller_field_templateObject());
var HelperTextP = (0,styled_components_browser_esm["default"])(ahm_ui.P).withConfig({
    componentId: "sc-eabad306-1"
})(traveller_field_templateObject1(), traveller_field_colors.grey50);
var LabelWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-eabad306-2"
})(traveller_field_templateObject2());
var traveller_field_StyledFormikField = (0,styled_components_browser_esm["default"])(ahm_ui/* FormikField */.Ub).withConfig({
    componentId: "sc-eabad306-3"
})(traveller_field_templateObject3(), traveller_field_media.lg);
var TravellersErrorText = (0,styled_components_browser_esm["default"])(ErrorText).withConfig({
    componentId: "sc-eabad306-4"
})(traveller_field_templateObject4(), traveller_field_mediaQueries.above(traveller_field_media.lg));
var TravellerFieldOuterWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-eabad306-5"
})(traveller_field_templateObject5());
var TravellerField = function(param) {
    var id = param.id, key = param.key, labelText = param.labelText, helperText = param.helperText, name = param.name, required = param.required;
    var ref = (0,formik_esm.useFormikContext)(), errors = ref.errors, touched = ref.touched, values = ref.values, setFieldValue = ref.setFieldValue;
    var currentFieldValue = values[name];
    // when a field is dynamic, using setFieldValue registers the value in the state
    (0,react.useEffect)(function() {
        if (!currentFieldValue) {
            setFieldValue(name, "");
        }
    }, []);
    var fieldError = errors[name];
    var isTouched = touched[name];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TravellerFieldOuterWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(traveller_field_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                id: "label-for-".concat(id),
                                htmlFor: name,
                                children: "".concat(required ? "".concat(labelText, "*") : "".concat(labelText))
                            }),
                            helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)(HelperTextP, {
                                children: helperText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(traveller_field_StyledFormikField, {
                        input: {
                            inputMode: "numeric",
                            pattern: "[0-9]*"
                        },
                        name: name,
                        id: id,
                        placeholder: "Age",
                        required: required,
                        type: "text",
                        hideErrorMessage: true
                    })
                ]
            }, key),
            fieldError && isTouched && /*#__PURE__*/ (0,jsx_runtime.jsx)(TravellersErrorText, {
                children: fieldError
            })
        ]
    });
};
/* harmony default export */ var traveller_field = (TravellerField);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/traveller-details/index.tsx








var MAX_TRAVELLER_COUNT = 9;
var CONTACT = (0,get_travel_insurance_constants/* default */.Z)().CONTACT;
var TravellerDetails = function() {
    var ref = use_travel_widget_context(), travellerCount = ref.travellerCount, setTravellerCount = ref.setTravellerCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(traveller_details_styles_ContentWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                looksLike: "h5",
                variant: "marginBottomSpacer9",
                children: "Traveller details"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(traveller_field, {
                helperText: "Current age of traveller",
                labelText: "Primary traveller",
                name: "travelerAge_1",
                required: true
            }),
            travellerCount === MAX_TRAVELLER_COUNT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MaxTravellerCountP, {
                children: [
                    "If there are more than 10 travellers please contact our Customer Service team on",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(traveller_details_styles_StyledClickable, {
                        to: "tel:".concat(CONTACT.PHONE.STANDARD),
                        children: CONTACT.PHONE.PRETTY
                    }),
                    " to discuss your travel insurance options."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(traveller_counter, {
                travellerCount: travellerCount,
                setTravellerCount: setTravellerCount
            }),
            Array.from({
                length: travellerCount
            }, function(_, index) {
                var travellerIndex = index + 2;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(traveller_field, {
                    labelText: "Traveller ".concat(travellerIndex),
                    name: "travelerAge_".concat(travellerIndex),
                    helperText: "Current age of traveller ".concat(travellerIndex),
                    id: "traveller-".concat(travellerIndex)
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckbox, {
                fieldLabel: "All travellers currently live in Australia and hold a valid Australian Medicare card or visa allowing them to live, work or study in Australia.",
                name: "resident",
                type: "checkbox",
                isRequired: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckbox, {
                fieldLabel: "Are you an ahm or Medibank member?",
                name: "isMember",
                type: "checkbox"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PromoLabelWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoLabel, {
                        htmlFor: "promoCode",
                        children: "Promo code "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoP, {
                        children: "(Optional)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoField, {
                name: "promoCode",
                type: "text"
            })
        ]
    });
};
/* harmony default export */ var traveller_details = (TravellerDetails);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/data.tsx




var fieldData = [
    {
        icon: "search",
        modalComponent: destination_suggestions,
        name: FIELD_NAMES.WHERE,
        placeholder: "Search destinations"
    },
    {
        icon: "calendar",
        modalComponent: date_picker,
        name: FIELD_NAMES.WHEN
    },
    {
        hasButton: true,
        icon: "user",
        modalComponent: traveller_details,
        name: FIELD_NAMES.WHO
    }, 
];
/* harmony default export */ var widget_data = (fieldData);

// EXTERNAL MODULE: ./node_modules/@ahmdigital/form-validation/lib/main.js
var main = __webpack_require__(91843);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/extract-city-from-parenthesis/index.ts


var extractCityFromParenthesis = function(searchTerm) {
    var regex = PARENTHESIS_MATCH_REGEX;
    var match = searchTerm.match(regex);
    if (!match) {
        return null;
    }
    var _match = (0,_sliced_to_array/* default */.Z)(match, 3), country = _match[1], city = _match[2];
    return {
        city: city,
        country: country
    };
};
/* harmony default export */ var extract_city_from_parenthesis = (extractCityFromParenthesis);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/get-is-match/index.ts

var getIsMatch = function(searchTerm, location) {
    return (0,fp.includes)((0,fp.toLower)(searchTerm), (0,fp.toLower)(location));
};
/* harmony default export */ var get_is_match = (getIsMatch);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/get-country-match/index.ts


var getCountryMatch = function(countries, searchTerm) {
    return (0,fp.flow)((0,fp.map)(function(country) {
        var hasMatchedCountry = get_is_match(searchTerm, country.label);
        if (hasMatchedCountry) {
            var region = country.region, id = country.id, label = country.label;
            return {
                city: null,
                country: label,
                hasMatchedCountry: hasMatchedCountry,
                label: label,
                value: "".concat(region, "-").concat(id)
            };
        }
        return null;
    }), fp.compact)(countries);
};
/* harmony default export */ var get_country_match = (getCountryMatch);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/get-matched-cities/index.ts


var filterCitiesByCountry = function(param) {
    var country = param.country, searchTerm = param.searchTerm;
    return (0,fp.filter)(function(city) {
        return get_is_match(searchTerm, city.label);
    }, country.cities);
};
var getMatchedCitiesFromCountry = function(matchedCountry, searchTerm, hasMatchedCountry) {
    if (!matchedCountry) {
        return null;
    }
    var cityMatches = filterCitiesByCountry({
        country: matchedCountry,
        searchTerm: searchTerm
    });
    if (!(0,fp.isEmpty)(cityMatches)) {
        var region = matchedCountry.region, id = matchedCountry.id, label = matchedCountry.label;
        var city = (0,fp.head)(cityMatches);
        return {
            city: city,
            country: label,
            hasMatchedCountry: hasMatchedCountry,
            label: "".concat(label, " (").concat(city === null || city === void 0 ? void 0 : city.label, ")"),
            value: "".concat(region, "-").concat(id, "-").concat(city === null || city === void 0 ? void 0 : city.id)
        };
    }
    return null;
};
var getMatchedCities = function(param) {
    var searchTerm = param.searchTerm, countries = param.countries, countryLabel = param.countryLabel;
    if (countryLabel) {
        var matchedCountry = (0,fp.find)(function(country) {
            return (0,fp.toLower)(country.label) === (0,fp.toLower)(countryLabel);
        }, countries);
        return [
            getMatchedCitiesFromCountry(matchedCountry, searchTerm, true)
        ];
    }
    return (0,fp.flow)((0,fp.map)(function(country) {
        return getMatchedCitiesFromCountry(country, searchTerm, false);
    }), fp.compact)(countries);
};
/* harmony default export */ var get_matched_cities = (getMatchedCities);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/get-countries-by-search/index.ts





var hasParenthesesFormat = function(searchTerm) {
    var regex = PARENTHESIS_MATCH_REGEX;
    return regex.test(searchTerm);
};
var PRIORITY_LOCATIONS = [
    "usa",
    "us",
    "nz",
    "uk"
];
var getCountriesBySearch = function(countries, searchTerm) {
    if (!searchTerm) {
        return [];
    }
    var lowerCaseSearchTerm = (0,fp.toLower)(searchTerm);
    // Matches priority locations
    var isPriorityLocation = (0,fp.includes)(lowerCaseSearchTerm, PRIORITY_LOCATIONS);
    if (isPriorityLocation) {
        var matchedCities = get_matched_cities({
            countries: countries,
            searchTerm: lowerCaseSearchTerm
        });
        var filteredCities = (0,fp.filter)(function(param) {
            var city = param.city;
            return !(0,fp.isEmpty)(city) && (0,fp.includes)((0,fp.toLower)(city === null || city === void 0 ? void 0 : city.label), PRIORITY_LOCATIONS);
        }, matchedCities);
        if (!(0,fp.isEmpty)(filteredCities)) {
            return filteredCities;
        }
    }
    var countryMatches = get_country_match(countries, lowerCaseSearchTerm);
    // If there are country matches, return them
    if (!(0,fp.isEmpty)(countryMatches)) {
        return countryMatches;
    }
    // The search term is in parentheses format eg 'Australia (Sydney)'
    var extractedValues = extract_city_from_parenthesis(lowerCaseSearchTerm);
    if (hasParenthesesFormat(lowerCaseSearchTerm) && extractedValues) {
        return get_matched_cities({
            countries: countries,
            countryLabel: extractedValues.country,
            searchTerm: extractedValues.city
        });
    }
    // If no matches, search for cities
    return get_matched_cities({
        countries: countries,
        searchTerm: lowerCaseSearchTerm
    });
};
/* harmony default export */ var get_countries_by_search = (getCountriesBySearch);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/get-maximum-children-and-adults/index.ts




var ADULT_AGE = 18;
var getMaximumChildrenAndAdults = function(travellerAgeFields) {
    var defaultValue = {
        amountOfAdults: 0,
        amountOfChildren: 0,
        indexOfAdultMaxAge: null,
        indexOfChildrenMaxAge: null
    };
    return (0,uncap_fp_iterator/* default */.Z)(fp.reduce)(function(result, value, key) {
        var fieldIndex = Number(key.split("_")[1]);
        var ageInt = Number(value);
        if (ageInt >= ADULT_AGE) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
                amountOfAdults: result.amountOfAdults + 1,
                indexOfAdultMaxAge: fieldIndex
            });
        }
        if (ageInt < ADULT_AGE) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
                amountOfChildren: result.amountOfChildren + 1,
                indexOfChildrenMaxAge: fieldIndex
            });
        }
        return result;
    }, defaultValue, travellerAgeFields);
};
/* harmony default export */ var get_maximum_children_and_adults = (getMaximumChildrenAndAdults);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/schema/index.ts






var MAX_AGE = 120;
var VALID_AGE_MESSAGE = "Enter a valid age";
var hasErrors = function(fieldNames, errors) {
    return (0,fp.some)(function(fieldName) {
        return (0,fp.has)(fieldName, errors);
    }, fieldNames);
};
var getTravellerFieldsData = function(allFormValues) {
    var travellerAgeFields = (0,fp.pickBy)(function(_, key) {
        return (0,fp.includes)("travelerAge_", key);
    }, allFormValues);
    return get_maximum_children_and_adults(travellerAgeFields);
};
var getTravellerFields = function(travellerCount) {
    var defaultValue = {};
    var arrayToIterate = Array.from({
        length: travellerCount
    }, function(_, i) {
        return i + 1;
    });
    return (0,fp.reduce)(function(result, value) {
        return (0,fp.set)("travelerAge_".concat(value), {
            initialValue: "",
            validation: [
                (0,main.required)(VALID_AGE_MESSAGE),
                (0,main.integer)("Enter a valid number"),
                (0,main.conditional)(function() {
                    return !!value;
                }, [
                    function(age) {
                        return age < 0 ? VALID_AGE_MESSAGE : undefined;
                    },
                    function(age) {
                        return age > MAX_AGE ? VALID_AGE_MESSAGE : undefined;
                    },
                    function(_, allFormValues) {
                        var ref = getTravellerFieldsData(allFormValues), amountOfAdults = ref.amountOfAdults, indexOfAdultMaxAge = ref.indexOfAdultMaxAge;
                        if (amountOfAdults > 4 && value === indexOfAdultMaxAge) {
                            return "If you are travelling with more than 4 adults please contact our Customer Service team on 1300 617 409 to discuss your travel insurance options.";
                        }
                        return undefined;
                    },
                    function(_, allFormValues) {
                        var ref = getTravellerFieldsData(allFormValues), amountOfChildren = ref.amountOfChildren, indexOfChildrenMaxAge = ref.indexOfChildrenMaxAge;
                        if (amountOfChildren > 6 && value === indexOfChildrenMaxAge) {
                            return "We are unable to provide a quote due to the combination of adults and children listed, please contact us on 1300 617 409 to discuss your options.";
                        }
                        return undefined;
                    }, 
                ]), 
            ]
        }, result);
    }, defaultValue, arrayToIterate);
};
var generateSchema = function(param) {
    var countries = param.countries, currentWidgetErrors = param.currentWidgetErrors, travellerCount = param.travellerCount;
    var travellerCountWithPrimary = travellerCount + 1;
    var schema = (0,_object_spread/* default */.Z)({
        departureDate: {
            initialValue: ""
        },
        destinations: {
            initialValue: ""
        },
        isMember: {
            initialValue: false
        },
        promoCode: {
            initialValue: ""
        },
        resident: {
            initialValue: false,
            validation: [
                (0,main.required)(),
                (0,main.checked)("Please check the box to confirm all travellers hold a valid Australian Medicare card or visa allowing them to live, work or study in Australia. Otherwise, contact our Customer Service team on 1300 617 409 to discuss."), 
            ]
        },
        returnDate: {
            initialValue: ""
        },
        when: {
            initialValue: "",
            validation: [
                (0,main.conditional)(function(param) {
                    var departureDate = param.departureDate, returnDate = param.returnDate;
                    return !departureDate || !returnDate;
                }, [
                    function(value) {
                        return !value ? "Fill in your travel dates to continue." : undefined;
                    }
                ]), 
            ]
        },
        where: {
            initialValue: "",
            validation: [
                (0,main.required)("Add your destination to continue."),
                (0,main.conditional)(function(param) {
                    var destinations = param.destinations, where = param.where;
                    return (0,fp.isEmpty)(destinations) || (0,fp.isEmpty)(get_countries_by_search(countries, where));
                }, [
                    function() {
                        return "Select destination from dropdown.";
                    }
                ]), 
            ]
        },
        who: {
            initialValue: "",
            validation: [
                (0,main.conditional)(function() {
                    return hasErrors(WHO_FIELD_NAMES, currentWidgetErrors);
                }, [
                    function() {
                        return "Enter your traveller details to continue.";
                    }
                ]), 
            ]
        }
    }, getTravellerFields(travellerCountWithPrimary));
    return {
        packagedSchema: (0,main.packageSchemaForFormik)(schema),
        rawSchema: schema
    };
};
/* harmony default export */ var schema = (generateSchema);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/handle-click-back/index.ts
var handleBackClick = function(param) {
    var currentModalIndex = param.currentModalIndex, setWidgetInactive = param.setWidgetInactive, toggleModal = param.toggleModal;
    if (currentModalIndex !== null && currentModalIndex > 0) {
        toggleModal(currentModalIndex, false);
        toggleModal(currentModalIndex - 1, true);
    }
    if (currentModalIndex === 0 || currentModalIndex === null) {
        setWidgetInactive();
    }
};
/* harmony default export */ var handle_click_back = (handleBackClick);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/handle-submit/index.ts


var handleSubmit = function(values, router) {
    var queryParams = lib_default().stringify(values);
    router.push("".concat(ahm_constants/* default.URLS.THIRD_PARTY.TRAVEL_INSURANCE_EXTERNAL */.Z.URLS.THIRD_PARTY.TRAVEL_INSURANCE_EXTERNAL, "/inbound-quote?").concat(queryParams));
};
/* harmony default export */ var handle_submit = (handleSubmit);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/offer-tongue/images/tongue-background.png
/* harmony default export */ var tongue_background = ({"src":"/_next/static/media/tongue-background.5f1dd2ea.png","height":53,"width":443,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJElEQVR4nGP88/XfFQYGBjUgZgRiZob/QJqR4S+Q/fM/A8NDAJjbCMaHTdcBAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/offer-tongue/styles.ts

function offer_tongue_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  align-items: center;\n  background-color: transparent;\n  background-image: url("',
        '");\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  border: none;\n  display: flex;\n  gap: 0.5rem;\n  height: 3.5rem;\n  justify-content: center;\n  margin: 0 auto;\n  padding: 0.75rem 0 0.5rem 0;\n  text-align: center;\n  width: 100%;\n  width: 17.5rem;\n\n  @media (min-width: ',
        ") {\n    padding: 0.5rem 0;\n    width: 27.75rem;\n  }\n"
    ], [
        '\n  align-items: center;\n  background-color: transparent;\n  background-image: url(\\"',
        '\\");\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  border: none;\n  display: flex;\n  gap: 0.5rem;\n  height: 3.5rem;\n  justify-content: center;\n  margin: 0 auto;\n  padding: 0.75rem 0 0.5rem 0;\n  text-align: center;\n  width: 100%;\n  width: 17.5rem;\n\n  @media (min-width: ',
        ") {\n    padding: 0.5rem 0;\n    width: 27.75rem;\n  }\n"
    ]);
    offer_tongue_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function offer_tongue_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 1rem;\n  padding-right: 2.25rem;\n"
    ]);
    offer_tongue_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function offer_tongue_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 1.75rem;\n  margin-top: 0.25rem;\n  padding-left: 2.25rem;\n  transform: rotate(-7deg);\n"
    ]);
    offer_tongue_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var offer_tongue_styles_OfferTongueWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1357c75-0"
})(offer_tongue_styles_templateObject(), tongue_background.src, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var OfferCopy = (0,styled_components_browser_esm["default"])(ahm_ui/* TypeWrapper */.f3).withConfig({
    componentId: "sc-1357c75-1"
})(offer_tongue_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.purple;
});
var OfferTag = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-1357c75-2"
})(offer_tongue_styles_templateObject2());

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/offer-tongue/index.tsx








var OfferTongue = function(param) {
    var offer = param.offer;
    var offerTitle = offer === null || offer === void 0 ? void 0 : offer.title;
    var offerFootnote = offer === null || offer === void 0 ? void 0 : offer.footnote;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(offer_tongue_styles_OfferTongueWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferTag, {
                src: offer_tag/* default.src */.Z.src,
                alt: "Offer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferCopy, {
                variant: "simpleBit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                    source: (0,insert_footnote_reference/* default */.Z)({
                        footnote: offerFootnote,
                        isPortableText: (0,fp.isPlainObject)(offerTitle) || (0,fp.isArray)(offerTitle),
                        text: offerTitle
                    }),
                    typeSerializers: (0,get_footnote_serializer/* default */.Z)({
                        footnote: offerFootnote,
                        variant: "footnote"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var offer_tongue = (OfferTongue);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/overlay/index.tsx

function overlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 100%;\n  left: 0;\n  opacity: 0;\n  position: fixed;\n  top: 0;\n  transition:\n    opacity 250ms linear,\n    visibility 0ms linear 250ms;\n  visibility: hidden;\n  width: 100%;\n  z-index: ",
        ";\n\n  ",
        ";\n"
    ]);
    overlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var overlay_zIndices = ahm_ui/* theme.zIndices */.rS.zIndices, overlay_colors = ahm_ui/* theme.colors */.rS.colors;
var OverlayWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2303d1f7-0"
})(overlay_templateObject(), overlay_colors.black, overlay_zIndices.reactModal, function(param) {
    var isShowing = param.isShowing;
    return isShowing && "\n      display: block;\n      opacity: 0.6;\n      transition-delay: 0ms;\n      visibility: visible;\n  ";
});
var Overlay = function(param) {
    var _isShowing = param.isShowing, isShowing = _isShowing === void 0 ? false : _isShowing, onClick = param.onClick;
    var windowObj = browser/* default.getWindow */.Z.getWindow();
    (0,react.useEffect)(function() {
        var close = function(event) {
            var keyboardEvent = event;
            if (keyboardEvent.key === "Escape") {
                var ref;
                onClick();
                (ref = browser/* default.getDocument */.Z.getDocument().activeElement) === null || ref === void 0 ? void 0 : ref.blur();
            }
        };
        windowObj.addEventListener("keydown", close);
        return function() {
            return windowObj.removeEventListener("keydown", close);
        };
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayWrapper, {
        isShowing: isShowing,
        onClick: onClick,
        "data-testid": "overlay",
        children: "\xa0"
    });
};
/* harmony default export */ var overlay = (Overlay);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/get-form-values-from-url/index.ts





var convertToBoolean = function(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    return value;
};
var getFormValuesFromUrl = function(param) {
    var countries = param.countries, destinationLocation = param.destinationLocation, _queryStringValues = param.queryStringValues, queryStringValues = _queryStringValues === void 0 ? {} : _queryStringValues, initialValues = param.initialValues;
    if ((0,fp.isEmpty)(countries)) {
        return null;
    }
    var formFieldNames = Object.values(FIELD_NAMES);
    var convertedQueryStringValues = (0,fp.mapValues)(convertToBoolean, queryStringValues);
    var widgetValuesFromQuery = (0,fp.pick)(formFieldNames, convertedQueryStringValues);
    var whereField = FIELD_NAMES.WHERE;
    var whereSearchTerm = destinationLocation || widgetValuesFromQuery[whereField];
    var whereSearchTermWithoutHyphen = whereSearchTerm === null || whereSearchTerm === void 0 ? void 0 : whereSearchTerm.replace("-", " ");
    var destinationCountry = (0,fp.head)(get_countries_by_search(countries, whereSearchTermWithoutHyphen));
    var _obj;
    var valuesFormattedToMatchForm = destinationCountry ? (_obj = {}, (0,_define_property/* default */.Z)(_obj, FIELD_NAMES.WHERE, destinationCountry.label), (0,_define_property/* default */.Z)(_obj, FIELD_NAMES.DESTINATIONS, destinationCountry.value), _obj) : {};
    return (0,_object_spread/* default */.Z)({}, initialValues, widgetValuesFromQuery, valuesFormattedToMatchForm);
};
/* harmony default export */ var get_form_values_from_url = (getFormValuesFromUrl);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/get-should-hide-separator/index.ts
var getShouldHideSeparator = function(activeIndex, index) {
    if (activeIndex === null) return false;
    return index === activeIndex || index === activeIndex - 1;
};
/* harmony default export */ var get_should_hide_separator = (getShouldHideSeparator);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/rehydrate-form/index.ts


var rehydrateForm = function(param) {
    var countries = param.countries, formikSessionStorageKey = param.formikSessionStorageKey, hasFormInitialized = param.hasFormInitialized, hasPersistedEventRun = param.hasPersistedEventRun, resetForm = param.resetForm, setHasFormInitialized = param.setHasFormInitialized, setSubmitting = param.setSubmitting, setTravellerCount = param.setTravellerCount, travellerCountSessionStorageKey = param.travellerCountSessionStorageKey, valuesFromUrl = param.valuesFromUrl;
    if (hasPersistedEventRun) {
        setHasFormInitialized(false);
        setSubmitting(false);
        return;
    }
    if (hasFormInitialized || (0,fp.isEmpty)(countries)) return;
    var sessionStorage = browser/* default.getWindow */.Z.getWindow().sessionStorage;
    var storedState = sessionStorage.getItem(formikSessionStorageKey);
    var amountOfTravellers = sessionStorage.getItem(travellerCountSessionStorageKey);
    var sessionStorageState = storedState ? JSON.parse(storedState) : null;
    if (!sessionStorageState && !amountOfTravellers && !valuesFromUrl) {
        setHasFormInitialized(true);
        return;
    }
    if (!(0,fp.isEmpty)(sessionStorageState) || !(0,fp.isEmpty)(valuesFromUrl)) {
        resetForm({
            values: !(0,fp.isEmpty)(sessionStorageState) ? sessionStorageState : valuesFromUrl
        });
    }
    if (amountOfTravellers) {
        setTravellerCount(Number(amountOfTravellers));
    }
    setSubmitting(false);
    setHasFormInitialized(true);
};
/* harmony default export */ var rehydrate_form = (rehydrateForm);

// EXTERNAL MODULE: ./src/client/analytics/index.ts + 6 modules
var analytics = __webpack_require__(86039);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/auto-complete-input/components/auto-complete-item/styles.tsx

function auto_complete_item_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 0.25rem;\n  cursor: pointer;\n  display: flex;\n  font-size: 20px;\n  padding: 1rem;\n\n  @media (min-width: ",
        ") {\n    min-width: 26.25rem;\n  }\n"
    ]);
    auto_complete_item_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function auto_complete_item_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 0.5rem;\n"
    ]);
    auto_complete_item_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SearchItem = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-fa0559ed-0"
})(auto_complete_item_styles_templateObject(), function(param) {
    var isHighlighted = param.isHighlighted, theme = param.theme;
    return isHighlighted ? theme.colors.grey10 : theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.media.lg;
});
var SearchIcon = (0,styled_components_browser_esm["default"])(lib["default"]).withConfig({
    componentId: "sc-fa0559ed-1"
})(auto_complete_item_styles_templateObject1());

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/auto-complete-input/components/auto-complete-item/index.tsx








var highlightMatches = function(param) {
    var city = param.city, country = param.country, searchTerm = param.searchTerm;
    var concatenatedString = "".concat(country).concat(city ? " (".concat(city, ")") : "");
    var escapedString = (0,fp.escapeRegExp)(searchTerm);
    var regex = new RegExp("(".concat(escapedString, ")"), "i");
    var parts = (0,fp.split)(regex, concatenatedString);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: (0,uncap_fp_iterator/* default */.Z)(fp.map)(function(part, index) {
            return regex.test(part) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                children: part
            }, index) : part;
        }, parts)
    });
};
var AutoCompleteItem = function(param) {
    var getItemProps = param.getItemProps, item = param.item, searchTerm = param.searchTerm, value = param.value, index = param.index, highlightedIndex = param.highlightedIndex;
    var ref;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(SearchItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getItemProps({
        index: index,
        item: item,
        key: value
    })), {
        isHighlighted: highlightedIndex === index,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {
                name: "map-marker",
                size: "medium"
            }),
            highlightMatches({
                city: (ref = item.city) === null || ref === void 0 ? void 0 : ref.label,
                country: item.country,
                searchTerm: searchTerm
            })
        ]
    }));
};
/* harmony default export */ var auto_complete_item = (AutoCompleteItem);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/auto-complete-input/components/auto-complete-menu/index.tsx





var Menu = function(param) {
    var getMenuProps = param.getMenuProps, isOpen = param.isOpen, menuItems = param.menuItems;
    if (!isOpen || (0,fp.isEmpty)(menuItems)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getMenuProps()), {
        children: menuItems
    }));
};
/* harmony default export */ var auto_complete_menu = (Menu);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/auto-complete-input/components/no-results/styles.tsx

function no_results_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.25rem;\n  @media (min-width: ",
        ") {\n    width: 26.25rem;\n  }\n"
    ]);
    no_results_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

// eslint-disable-next-line import/prefer-default-export
var NoResultsContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-65e78e46-0"
})(no_results_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/auto-complete-input/components/no-results/index.tsx




var NoResultsMessage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResultsContent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                    children: "Location not found."
                }),
                " Please check you have the correct destination."
            ]
        })
    });
};
/* harmony default export */ var no_results = (NoResultsMessage);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/portal-wrapper/index.tsx


var PortalWrapper = function(param) {
    var children = param.children, hasRef = param.hasRef, modalContentRef = param.modalContentRef;
    return hasRef && modalContentRef.current ? /*#__PURE__*/ (0,react_dom.createPortal)(children, modalContentRef.current) : null;
};
/* harmony default export */ var portal_wrapper = (PortalWrapper);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/auto-complete-input/index.tsx















var MIN_QUERY_LENGTH = 2;
var QUERY_DELAY = 300;
var MAX_RESULTS = 5;
var AutoCompleteInput = function(param) {
    var autoCompleteRef = param.autoCompleteRef, modalContentRef = param.modalContentRef, name = param.name, placeholder = param.placeholder, setIsSuggestionsOpen = param.setIsSuggestionsOpen, setIsModalOpen = param.setIsModalOpen;
    var ref = use_travel_widget_context(), countries = ref.countries, setCountries = ref.setCountries;
    var ref1 = (0,formik_esm.useFormikContext)(), values = ref1.values, setFieldValue = ref1.setFieldValue;
    var ref2 = (0,react.useState)(false), autoCompleteLoading = ref2[0], setAutoCompleteLoading = ref2[1];
    var ref3 = (0,react.useState)(null), autoCompleteMenuItems = ref3[0], setAutoCompleteMenuItems = ref3[1];
    (0,react.useEffect)(function() {
        var getCountries = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var countriesList;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetch("/travel-insurance-widget/countries.json").then(function(response) {
                                    return response.json();
                                })
                            ];
                        case 1:
                            countriesList = _state.sent();
                            setCountries(countriesList);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getCountries() {
                return _ref.apply(this, arguments);
            };
        }();
        getCountries();
    }, []);
    var onSearchValueUpdated = function() {
        return function(innerValue) {
            if (innerValue.length < MIN_QUERY_LENGTH) {
                setAutoCompleteMenuItems(null);
                setIsSuggestionsOpen(false);
                return;
            }
            setIsSuggestionsOpen(true);
            setIsModalOpen(false);
            setAutoCompleteLoading(true);
            var result = (0,fp.compact)(get_countries_by_search(countries, innerValue));
            var limitedResult = (0,fp.take)(MAX_RESULTS, result);
            setAutoCompleteLoading(false);
            setAutoCompleteMenuItems(limitedResult);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFormikField, {
        label: "".concat((0,fp.upperFirst)(name)),
        name: name,
        required: true,
        size: "auto",
        placeholder: placeholder,
        htmlFor: name,
        id: name,
        onSearchValueUpdated: (0,fp.debounce)(QUERY_DELAY, onSearchValueUpdated()),
        onSelectedValueChange: function(value) {
            setIsModalOpen(false);
            setIsSuggestionsOpen(false);
            setFieldValue(FIELD_NAMES.DESTINATIONS, value);
        },
        selectPropertyOnSelection: "value" // specifies which property of the selected item should be used to update the form field value
        ,
        displayPropertyOnSelection: "label" // specifies which property of the selected item should be displayed in the input field when an item is selected
        ,
        type: "autocompleteFormik",
        items: autoCompleteMenuItems,
        isLoading: autoCompleteLoading,
        renderNoResults: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(portal_wrapper, {
                hasRef: !!modalContentRef.current,
                modalContentRef: modalContentRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(no_results, {})
            });
        },
        renderItem: function(param) {
            var item = param.item, index = param.index, getItemProps = param.getItemProps, highlightedIndex = param.highlightedIndex;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(auto_complete_item, {
                item: item,
                highlightedIndex: highlightedIndex,
                getItemProps: getItemProps,
                index: index,
                value: item.country,
                searchTerm: values.where
            });
        },
        renderMenu: function(renderProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(portal_wrapper, {
                hasRef: !!modalContentRef.current,
                modalContentRef: modalContentRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auto_complete_menu, (0,_object_spread/* default */.Z)({}, renderProps))
            });
        },
        inputVariant: "unstyled",
        innerRef: autoCompleteRef,
        hideErrorMessage: true
    });
};
/* harmony default export */ var auto_complete_input = (AutoCompleteInput);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/get-panel-index-for-error/index.ts



var FIRST_MODAL_FIELDS = [
    FIELD_NAMES.WHERE
];
var SECOND_MODAL_FIELDS = [
    FIELD_NAMES.WHEN
].concat((0,_to_consumable_array/* default */.Z)(WHEN_FIELD_NAMES));
var THIRD_MODAL_FIELDS = [
    FIELD_NAMES.WHO
].concat((0,_to_consumable_array/* default */.Z)(WHO_FIELD_NAMES));
var MODAL_FIELDS = [
    {
        fields: FIRST_MODAL_FIELDS,
        index: 0
    },
    {
        fields: SECOND_MODAL_FIELDS,
        index: 1
    },
    {
        fields: THIRD_MODAL_FIELDS,
        index: 2
    }, 
];
var getPanelIndexForError = function(param) {
    var errors = param.errors;
    var errorFields = (0,fp.keys)(errors);
    if ((0,fp.isEmpty)(errorFields)) {
        return null;
    }
    var matchingPanel = (0,fp.find)(function(param) {
        var fields = param.fields;
        return (0,fp.some)(function(field) {
            return (0,fp.includes)(field, fields);
        }, errorFields);
    }, MODAL_FIELDS);
    if (!matchingPanel) {
        return null;
    }
    return matchingPanel ? matchingPanel.index : null;
};
/* harmony default export */ var get_panel_index_for_error = (getPanelIndexForError);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/step-input/index.tsx















var StepInput = function(param) {
    var handleCloseWidgetOnTab = param.handleCloseWidgetOnTab, _hasButton = param.hasButton, hasButton = _hasButton === void 0 ? false : _hasButton, icon = param.icon, index = param.index, isFirst = param.isFirst, isLast = param.isLast, isModalOpen = param.isModalOpen, ModalComponent = param.modalComponent, name = param.name, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, placeholder = param.placeholder, setIsModalOpen = param.setIsModalOpen;
    var sharedInputProps = {
        isLast: isLast,
        label: "".concat((0,fp.upperFirst)(name), "*"),
        name: name,
        placeholder: placeholder
    };
    var travellerCount = use_travel_widget_context().travellerCount;
    var sectionRef = (0,react.useRef)(null);
    var modalContentRef = (0,react.useRef)(null);
    var autoCompleteRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isSuggestionsOpen = ref[0], setIsSuggestionsOpen = ref[1];
    var ref1 = (0,react.useState)(false), hasError = ref1[0], setHasError = ref1[1];
    var ref2 = (0,react.useState)(false), isButtonHovered = ref2[0], setIsButtonHovered = ref2[1];
    var ref3 = (0,formik_esm.useFormikContext)(), handleSubmit = ref3.handleSubmit, errors = ref3.errors, isSubmitting = ref3.isSubmitting, values = ref3.values, setFieldTouched = ref3.setFieldTouched, submitCount = ref3.submitCount;
    var errorText = errors[name];
    var showErrorText = errorText && isModalOpen && hasError;
    var formatDate = function(date) {
        return moment_default()(date, ahm_constants/* default.DATE_FORMAT.STANDARD */.Z.DATE_FORMAT.STANDARD).format((0,fp.toUpper)(DEFAULT_DATE_FORMAT));
    };
    var getWhenValue = function() {
        return "".concat(values.departureDate ? formatDate(values.departureDate) : DEFAULT_DATE_FORMAT, " - ").concat(values.returnDate ? formatDate(values.returnDate) : DEFAULT_DATE_FORMAT, " ");
    };
    var totalNumberOfTravellers = values.travelerAge_1 ? travellerCount + 1 : 0;
    var getWhoValue = function() {
        return totalNumberOfTravellers ? "".concat(totalNumberOfTravellers, " traveller").concat(totalNumberOfTravellers > 1 ? "s" : "") : "Traveller details";
    };
    var firstErrorPanelIndex = get_panel_index_for_error({
        errors: errors
    });
    (0,react.useEffect)(function() {
        if (firstErrorPanelIndex === null) {
            setHasError(false);
            return;
        }
        var isCurrentPanel = firstErrorPanelIndex === index && !!isModalOpen;
        if (submitCount > 0) {
            setHasError(isCurrentPanel);
            if (isCurrentPanel) {
                var ref;
                (ref = sectionRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }
        }
    }, [
        firstErrorPanelIndex,
        isSubmitting,
        isModalOpen
    ]);
    var handleFocus = function() {
        setIsModalOpen(true);
    };
    var handleClick = function() {
        var ref;
        (ref = autoCompleteRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        analytics/* default.publish */.Z.publish("action", {
            action: "Clicked",
            component: "Element",
            label: "Get a quote ".concat(name)
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        isLast: isLast,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldWrapper, {
                hasError: hasError,
                isFirst: isFirst,
                isLast: isLast,
                isOpen: isModalOpen || isSuggestionsOpen,
                isButtonHovered: isButtonHovered,
                onFocus: handleFocus,
                onBlur: function() {
                    setIsSuggestionsOpen(false);
                },
                tabIndex: 0,
                hasButton: hasButton,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                ref: sectionRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, {
                    hasError: hasError,
                    isOpen: isModalOpen || isSuggestionsOpen,
                    isFirst: isFirst,
                    isLast: isLast,
                    hasButton: hasButton,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerInputWrapper, {
                            children: [
                                name === FIELD_NAMES.WHERE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(auto_complete_input, (0,_object_spread/* default */.Z)({
                                    setIsModalOpen: setIsModalOpen,
                                    modalContentRef: modalContentRef,
                                    setIsSuggestionsOpen: setIsSuggestionsOpen,
                                    autoCompleteRef: autoCompleteRef
                                }, sharedInputProps)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleWrapper, {
                                    isLast: isLast,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Label, {
                                            children: [
                                                (0,fp.upperFirst)(name),
                                                "*"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderText, {
                                            hasValue: name === FIELD_NAMES.WHEN ? values === null || values === void 0 ? void 0 : values.departureDate : values === null || values === void 0 ? void 0 : values.travelerAge_1,
                                            children: name === FIELD_NAMES.WHEN ? getWhenValue() : getWhoValue()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], {
                                        name: icon,
                                        size: "medium"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                            xs: true,
                            sm: true,
                            md: true,
                            lg: true,
                            children: showErrorText && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                                children: errorText
                            })
                        })
                    ]
                })
            }),
            isSuggestionsOpen && !isModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {
                isFirst: isFirst,
                isLast: isLast,
                hasError: hasError,
                isOpen: isSuggestionsOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: modalContentRef
                })
            }),
            isModalOpen && !isSuggestionsOpen && ModalComponent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalWrapper, {
                isFirst: isFirst,
                isLast: isLast,
                hasError: hasError,
                isOpen: isModalOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                        df: true,
                        xl: true,
                        children: showErrorText && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                            children: errorText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalComponent, {
                        autoCompleteRef: autoCompleteRef,
                        setIsModalOpen: setIsModalOpen,
                        setFieldTouched: setFieldTouched
                    })
                ]
            }),
            hasButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                xs: true,
                sm: true,
                md: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(step_input_styles_StyledButton, {
                    icon: {
                        name: "arrow-right-long",
                        position: "right",
                        size: "large"
                    },
                    onClick: handleSubmit,
                    variant: "flair",
                    onMouseEnter: function() {
                        setIsButtonHovered(true);
                        onMouseEnter();
                    },
                    onMouseLeave: function() {
                        return setIsButtonHovered(false);
                    },
                    isLoading: isSubmitting,
                    onKeyDown: handleCloseWidgetOnTab,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                        lg: true,
                        children: "Get quote"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var step_input = (StepInput);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/utils/open-modal-by-error/index.ts


var openModalByError = function(param) {
    var errors = param.errors, toggleModal = param.toggleModal, setIsWidgetActive = param.setIsWidgetActive;
    var errorFields = (0,fp.keys)(errors);
    var firstErrorPanelIndex = get_panel_index_for_error({
        errors: errors
    });
    if ((0,fp.isEmpty)(errorFields) || firstErrorPanelIndex === null) {
        return null;
    }
    toggleModal(firstErrorPanelIndex, true);
    setIsWidgetActive(true);
    return null;
};
/* harmony default export */ var open_modal_by_error = (openModalByError);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/hooks/use-open-panel-on-error/index.ts



var UseOpenPanelOnError = function(param) {
    var toggleModal = param.toggleModal, setIsWidgetActive = param.setIsWidgetActive;
    var ref = (0,formik_esm.useFormikContext)(), errors = ref.errors, isValid = ref.isValid, isSubmitting = ref.isSubmitting;
    (0,react.useEffect)(function() {
        if (isSubmitting && !isValid) {
            open_modal_by_error({
                errors: errors,
                setIsWidgetActive: setIsWidgetActive,
                toggleModal: toggleModal
            });
        }
    }, [
        isValid,
        isSubmitting
    ]);
};
/* harmony default export */ var use_open_panel_on_error = (UseOpenPanelOnError);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/components/widget-form/index.tsx




















var mapWithKey = (0,uncap_fp_iterator/* default */.Z)(fp.map);
var WidgetForm = function(param) {
    var handleCloseWidgetOnTab = param.handleCloseWidgetOnTab, modalStates = param.modalStates, toggleModal = param.toggleModal, setIsWidgetActive = param.setIsWidgetActive;
    var windowObj = browser/* default.getWindow */.Z.getWindow();
    var ref = use_travel_widget_context(), countries = ref.countries, travellerCount = ref.travellerCount, setTravellerCount = ref.setTravellerCount, setCurrentWidgetErrors = ref.setCurrentWidgetErrors, currentWidgetErrors = ref.currentWidgetErrors;
    var ref1 = (0,formik_esm.useFormikContext)(), initialValues = ref1.initialValues, handleSubmit = ref1.handleSubmit, isSubmitting = ref1.isSubmitting, resetForm = ref1.resetForm, setSubmitting = ref1.setSubmitting, values = ref1.values, errors = ref1.errors, validateForm = ref1.validateForm;
    var ref2 = (0,react.useState)(null), hoveredIndex = ref2[0], setHoveredIndex = ref2[1];
    var ref3 = (0,react.useState)(false), hasFormInitialized = ref3[0], setHasFormInitialized = ref3[1];
    use_open_panel_on_error({
        setIsWidgetActive: setIsWidgetActive,
        toggleModal: toggleModal
    });
    var router = (0,next_router.useRouter)();
    var destinationLocation = router.query.productOptionValue;
    var formikSessionStorageKey = "".concat(SESSION_STORAGE_KEYS.FORMIK_STATE).concat(destinationLocation ? "-".concat(destinationLocation) : "");
    var travellerCountSessionStorageKey = "".concat(SESSION_STORAGE_KEYS.TRAVELLER_COUNT).concat(destinationLocation ? "-".concat(destinationLocation) : "");
    var valuesFromUrl = get_form_values_from_url({
        countries: countries,
        destinationLocation: destinationLocation,
        initialValues: initialValues,
        queryStringValues: router.query
    });
    var rehydrateFormParams = {
        countries: countries,
        formikSessionStorageKey: formikSessionStorageKey,
        hasFormInitialized: hasFormInitialized,
        resetForm: resetForm,
        setHasFormInitialized: setHasFormInitialized,
        setSubmitting: setSubmitting,
        setTravellerCount: setTravellerCount,
        travellerCountSessionStorageKey: travellerCountSessionStorageKey,
        valuesFromUrl: valuesFromUrl
    };
    (0,react.useEffect)(function() {
        setCurrentWidgetErrors(errors);
    }, [
        errors,
        setCurrentWidgetErrors
    ]);
    (0,react.useEffect)(function() {
        validateForm();
    }, [
        currentWidgetErrors
    ]);
    (0,react.useEffect)(function() {
        var handlePageShow = function(event) {
            var pageTransitionEvent = event;
            // indicates the page has loaded from a cache (specifically the safari back/forward cache)
            if (pageTransitionEvent.persisted) {
                rehydrate_form((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rehydrateFormParams), {
                    hasPersistedEventRun: true
                }));
            }
        };
        rehydrate_form((0,_object_spread/* default */.Z)({}, rehydrateFormParams));
        windowObj.addEventListener("pageshow", handlePageShow);
        return function() {
            windowObj.removeEventListener("pageshow", handlePageShow);
        };
    }, [
        countries,
        valuesFromUrl
    ]);
    (0,react.useEffect)(function() {
        // we only want to start storing the values when we have checked if we need to rehydrate the form
        if (hasFormInitialized) {
            windowObj.sessionStorage.setItem(formikSessionStorageKey, JSON.stringify(values));
            windowObj.sessionStorage.setItem(travellerCountSessionStorageKey, travellerCount.toString());
        }
    }, [
        values,
        travellerCount,
        countries,
        hasFormInitialized
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledForm, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormWrapper, {
                children: mapWithKey(function(field, index) {
                    var isFirst = index === 0;
                    var isLast = index === widget_data.length - 1;
                    var isActive = modalStates[index] === true;
                    var prevPanelHideSeparator = modalStates[index + 1] === true;
                    var showInputSeparator = !(get_should_hide_separator(hoveredIndex, index) || isActive || prevPanelHideSeparator);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(step_input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                isFirst: isFirst,
                                isLast: isLast,
                                isModalOpen: modalStates[index],
                                setIsModalOpen: function(value) {
                                    toggleModal(index, value);
                                    if (value) {
                                        setIsWidgetActive(true);
                                    }
                                },
                                index: index,
                                onMouseEnter: function() {
                                    return setHoveredIndex(index);
                                },
                                onMouseLeave: function() {
                                    return setHoveredIndex(null);
                                },
                                setIsWidgetActive: setIsWidgetActive,
                                handleCloseWidgetOnTab: handleCloseWidgetOnTab
                            }), index),
                            !isLast && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputSeparator, {
                                isVisible: showInputSeparator,
                                className: "input-separator"
                            })
                        ]
                    });
                }, widget_data)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                df: true,
                xl: true,
                lg: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(widget_styles_StyledButton, {
                        icon: {
                            name: "arrow-right-long",
                            position: "right",
                            size: "large"
                        },
                        onClick: handleSubmit,
                        type: "submit",
                        variant: "flair",
                        isLoading: isSubmitting,
                        children: "Get quote"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var widget_form = (WidgetForm);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/components/widget/index.tsx





















var widget_colors = ahm_ui/* theme.colors */.rS.colors;
var widget_mapWithKey = (0,uncap_fp_iterator/* default */.Z)(fp.map);
var TravelWidget = function(param) {
    var isWidgetActive = param.isWidgetActive, offer = param.offer, setIsWidgetActive = param.setIsWidgetActive, isDestinationPage = param.isDestinationPage;
    var ref = use_travel_widget_context(), countries = ref.countries, currentWidgetErrors = ref.currentWidgetErrors, travellerCount = ref.travellerCount;
    var packagedSchema = schema({
        countries: countries,
        currentWidgetErrors: currentWidgetErrors,
        travellerCount: travellerCount
    }).packagedSchema;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)((0,fp.map)(function() {
        return false;
    }, widget_data)), modalStates = ref1[0], setModalStates = ref1[1];
    var ref2 = (0,react.useState)(null), currentModalIndex = ref2[0], setCurrentModalIndex = ref2[1];
    var widgetWrapperRef = (0,react.useRef)(null);
    var toggleModal = function(modalPosition, value) {
        setModalStates(function(modalState) {
            return widget_mapWithKey(function(_state, index) {
                return index === modalPosition ? value : false;
            }, modalState);
        });
        setCurrentModalIndex(value ? modalPosition : null);
    };
    var closeAllModals = function() {
        setModalStates(function(modalState) {
            return widget_mapWithKey(function() {
                return false;
            }, modalState);
        });
    };
    var setWidgetInactive = function() {
        setIsWidgetActive(false);
        closeAllModals();
    };
    var documentObj = browser/* default.getDocument */.Z.getDocument();
    (0,react.useEffect)(function() {
        if (isWidgetActive && device/* default.isMobile */.Z.isMobile()) {
            documentObj.body.style.overflow = "hidden";
        }
        return function() {
            documentObj.body.style.overflow = "auto";
        };
    }, [
        isWidgetActive
    ]);
    (0,react.useEffect)(function() {
        if (isWidgetActive) {
            var ref;
            (ref = widgetWrapperRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        isWidgetActive
    ]);
    var TAB_KEY = "Tab";
    // when tabbing back off the widget
    var handleCloseWidgetOnShiftTab = function(event) {
        if (event.key === TAB_KEY && event.shiftKey) {
            setWidgetInactive();
        }
    };
    // when tabbing forward off the widget
    var handleCloseWidgetOnTab = function(event) {
        if (event.key === TAB_KEY && !event.shiftKey) {
            setWidgetInactive();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                df: true,
                xl: true,
                lg: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileToggleWrapper, {
                    displayMobileToggle: !isWidgetActive,
                    isDestinationPage: isDestinationPage,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_OfferTongueWrapper, {
                            displayOffer: !isWidgetActive,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_tongue, {
                                offer: offer
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileToggle, {
                            displayMobileToggle: !isWidgetActive,
                            onClick: function() {
                                return setIsWidgetActive(true);
                            },
                            isUnstyled: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_HeadingWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledH2, {
                                            looksLike: "h5",
                                            children: "Get a quote"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledP, {
                                            children: "Where, When, Who"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileButton, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], {
                                        name: "arrow-right",
                                        fill: widget_colors.white,
                                        size: "large"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                xs: true,
                sm: true,
                md: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(overlay, {
                    isShowing: isWidgetActive,
                    onClick: setWidgetInactive
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetWrapper, {
                displayWidget: isWidgetActive,
                isActive: isWidgetActive,
                ref: widgetWrapperRef,
                isDestinationPage: isDestinationPage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuWrapper, {
                        children: [
                            isWidgetActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                                "aria-label": "Close quote",
                                onClick: setWidgetInactive,
                                onKeyDown: handleCloseWidgetOnShiftTab,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], {
                                    name: "cross-light",
                                    fill: widget_colors.black
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                                xs: true,
                                sm: true,
                                md: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_OfferTongueWrapper, {
                                    displayOffer: !isWidgetActive,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_tongue, {
                                        offer: offer
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                looksLike: "h4",
                                children: "Get a travel quote"
                            }),
                            isWidgetActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                                onClick: function() {
                                    return handle_click_back({
                                        currentModalIndex: currentModalIndex,
                                        setWidgetInactive: setWidgetInactive,
                                        toggleModal: toggleModal
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib["default"], {
                                    name: "app-chevron-left",
                                    fill: widget_colors.black
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelSpacer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                            children: "All fields marked with * are required"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileScrollWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm.Formik, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, packagedSchema), {
                            onSubmit: function(formValues) {
                                return handle_submit(formValues, router);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(widget_form, {
                                handleCloseWidgetOnTab: handleCloseWidgetOnTab,
                                modalStates: modalStates,
                                toggleModal: toggleModal,
                                setIsWidgetActive: setIsWidgetActive
                            })
                        }))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var widget = (TravelWidget);

;// CONCATENATED MODULE: ./src/client/pages/travel-insurance/components/header/index.tsx










var Header = function(param) {
    var title = param.title, offer = param.offer, image = param.image, subtitle = param.subtitle;
    var ref = (0,react.useState)(false), isWidgetActive = ref[0], setIsWidgetActive = ref[1];
    var router = (0,next_router.useRouter)();
    var productOptionValue = router.query.productOptionValue;
    var FooterContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelWidgetProvider, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(widget, {
                    isWidgetActive: isWidgetActive,
                    offer: offer,
                    setIsWidgetActive: setIsWidgetActive,
                    isDestinationPage: !!productOptionValue
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(awards, {})
        ]
    });
    if (productOptionValue) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* HeroBanner */.yo, {
            title: title,
            subtitle: subtitle,
            image: device/* default.isLargeTabletOrMobile */.Z.isLargeTabletOrMobile() ? null : image,
            footer: FooterContent
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
        hideBorderTop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
            padding: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverflowWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaneVideoWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                autoPlay: true,
                                muted: true,
                                playsInline: true,
                                height: "500px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: ahm_constants_ui.SANITY_MEDIA_FILES.PLANE_VIDEO,
                                    type: "video/mp4"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(header_styles_ContentWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSection, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_TitleWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                                            source: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                                                source: subtitle
                                            })
                                        })
                                    ]
                                })
                            }),
                            FooterContent
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var header = (Header);

// EXTERNAL MODULE: ./src/client/pages/insurance/components/value-propositions/index.tsx
var value_propositions = __webpack_require__(37594);
;// CONCATENATED MODULE: ./src/client/pages/insurance/index.tsx





























// @ts-expect-error - Automatic, Please fix when editing this file
var getComponents = function(insuranceType, productOptionValue) {
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.ADD_ONS */.i.ADD_ONS, add_ons_section), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.AWARD */.i.AWARD, award/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.COMMON_QUESTIONS */.i.COMMON_QUESTIONS, common_questions/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.COMMON_QUESTIONS_ALTERNATE */.i.COMMON_QUESTIONS_ALTERNATE, common_questions/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.FEATURES_AND_BENEFITS */.i.FEATURES_AND_BENEFITS, features_and_benefits), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.FORMS_AND_GUIDES */.i.FORMS_AND_GUIDES, forms_and_guides), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.HEADER */.i.HEADER, insuranceType === constants/* INSURANCE_TYPES.TRAVEL */.oK.TRAVEL ? header : ahm_ui/* HeroBanner */.yo), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.CORE_BENEFITS */.i.CORE_BENEFITS, core_benefits_section), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.COVER_INCLUSIONS */.i.COVER_INCLUSIONS, cover_inclusions), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.INCLUSIONS */.i.INCLUSIONS, inclusions/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.OFFER_STRIP */.i.OFFER_STRIP, strip_section), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.PROMOTIONS */.i.PROMOTIONS, promotions), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.PRODUCTS */.i.PRODUCTS, item_section), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.QUICK_LINKS */.i.QUICK_LINKS, quick_links/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.TERMS_AND_CONDITIONS */.i.TERMS_AND_CONDITIONS, terms_and_conditions/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.CONTACT_DETAILS */.i.CONTACT_DETAILS, contact_details/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.TILES */.i.TILES, information_section/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.VALUE_PROPOSITIONS */.i.VALUE_PROPOSITIONS, value_propositions/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.CROSS_SELL */.i.CROSS_SELL, cross_sell_section), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.POPULAR_DESTINATIONS */.i.POPULAR_DESTINATIONS, insuranceType === constants/* INSURANCE_TYPES.TRAVEL */.oK.TRAVEL && !productOptionValue ? popular_destinations_section : null), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.ARTICLES */.i.ARTICLES, articles_section), _obj;
};
var InsurancePage = function(param) {
    var content = param.content, insuranceType = param.insuranceType, productOptionValue = param.productOptionValue;
    var ref, ref1, ref2, ref3, ref4;
    var title = (content === null || content === void 0 ? void 0 : (ref = content.metadataObject) === null || ref === void 0 ? void 0 : ref.title) || "".concat((0,fp.upperFirst)(insuranceType), " insurance");
    var description = content === null || content === void 0 ? void 0 : (ref1 = content.metadataObject) === null || ref1 === void 0 ? void 0 : ref1.description;
    var titleTemplate = "%s - ahm insurance";
    var brandCampaignData = (0,fp.head)(content === null || content === void 0 ? void 0 : content.brandCampaigns);
    var metaDataImage = (brandCampaignData === null || brandCampaignData === void 0 ? void 0 : (ref2 = brandCampaignData.imageObject) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.asset) === null || ref4 === void 0 ? void 0 : ref4.url) || undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
                titleTemplate: titleTemplate,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:title",
                        content: (0,fp.replace)(titleTemplate, "%s", title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: (0,fp.replace)(titleTemplate, "%s", title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:image",
                        content: metaDataImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image:src",
                        content: metaDataImage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(page_sections/* default */.Z, {
                components: getComponents(insuranceType, productOptionValue),
                content: content,
                insuranceType: insuranceType
            })
        ]
    });
};
/* harmony default export */ var insurance = (InsurancePage);


/***/ }),

/***/ 70033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ combine_content_with_cms_data; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./src/client/pages/insurance/content/sections/index.ts
var content_sections = __webpack_require__(58699);
;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/get-all-questions/index.ts


var getAllQuestions = function(param) {
    var cmsData = param.cmsData;
    var ref;
    var ref1;
    var questions = (ref1 = cmsData === null || cmsData === void 0 ? void 0 : cmsData.questions) !== null && ref1 !== void 0 ? ref1 : [];
    var commonQuestionsAlternate = (cmsData === null || cmsData === void 0 ? void 0 : (ref = cmsData.commonQuestions) === null || ref === void 0 ? void 0 : ref.questions) || [];
    return (0,fp.compact)((0,_to_consumable_array/* default */.Z)(questions).concat((0,_to_consumable_array/* default */.Z)(commonQuestionsAlternate)));
};
/* harmony default export */ var get_all_questions = (getAllQuestions);

// EXTERNAL MODULE: ./src/client/utils/get-formatted-question-for-accordion/index.ts
var get_formatted_question_for_accordion = __webpack_require__(80365);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/content/utils/portable-text-to-plain/index.js
var portable_text_to_plain = __webpack_require__(64355);
var portable_text_to_plain_default = /*#__PURE__*/__webpack_require__.n(portable_text_to_plain);
;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/get-meta-data/index.ts

var getMetaData = function(cmsData, staticContent) {
    var ref, ref1, ref2, ref3;
    var ref4;
    var staticTitle = (ref4 = staticContent === null || staticContent === void 0 ? void 0 : (ref = staticContent.meta) === null || ref === void 0 ? void 0 : ref.title) !== null && ref4 !== void 0 ? ref4 : null;
    var ref5;
    var staticDescription = (ref5 = staticContent === null || staticContent === void 0 ? void 0 : (ref1 = staticContent.meta) === null || ref1 === void 0 ? void 0 : ref1.description) !== null && ref5 !== void 0 ? ref5 : null;
    var cmsTitle = cmsData === null || cmsData === void 0 ? void 0 : (ref2 = cmsData.metadataObject) === null || ref2 === void 0 ? void 0 : ref2.title;
    var cmsDescription = portable_text_to_plain_default()(cmsData === null || cmsData === void 0 ? void 0 : (ref3 = cmsData.metadataObject) === null || ref3 === void 0 ? void 0 : ref3.description);
    return {
        description: cmsDescription || staticDescription,
        title: cmsTitle || staticTitle
    };
};
/* harmony default export */ var get_meta_data = (getMetaData);

// EXTERNAL MODULE: ./src/client/cms/utils/get-image-attributes/index.ts
var get_image_attributes = __webpack_require__(51413);
;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-add-ons-content/index.ts




var mapAddOnsContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    var descriptionRaw = cmsSectionContent.descriptionRaw, name = cmsSectionContent.name, productOptions = cmsSectionContent.productOptions;
    var formattedContent = {
        description: portable_text_to_plain_default()(descriptionRaw),
        tiles: (0,fp.map)(function(option) {
            return {
                image: (0,get_image_attributes/* default */.Z)({
                    imageObject: option.imageObject
                }),
                summary: portable_text_to_plain_default()(option.descriptionRaw),
                title: option.name
            };
        }, productOptions),
        title: name
    };
    return {
        content: formattedContent,
        type: content_sections/* CONTENT_SECTIONS.ADD_ONS */.i.ADD_ONS
    };
};
/* harmony default export */ var map_add_ons_content = (mapAddOnsContent);

;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-articles/index.ts


var mapArticlesContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    return {
        articles: cmsSectionContent,
        type: content_sections/* CONTENT_SECTIONS.ARTICLES */.i.ARTICLES
    };
};
/* harmony default export */ var map_articles = (mapArticlesContent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/insert-award-tiles/index.ts



var reduceWithIndex = (0,uncap_fp_iterator/* default */.Z)(fp.reduce);
// @ts-expect-error - Automatic, Please fix when editing this file
var INITIAL_VALUE = [];
var MAX_AWARD_TILES = 2;
var SPACE_BETWEEN_TILES = 3;
/*
 * Insert award tiles into the sections array at a fixed interval.
 * The interval is defined by the SPACE_BETWEEN_TILES constant.
 * The maximum number of award tiles to insert is defined by the MAX_AWARD_TILES constant.
 * The awards will sit after the promo banner if it exists. If not they will sit after the first section.
 */ var insertAwardTiles = function(param) {
    var awardTiles = param.awardTiles, sections = param.sections;
    if ((0,fp.isEmpty)(awardTiles)) {
        return sections;
    }
    var limitedAwardTiles = awardTiles.slice(0, MAX_AWARD_TILES);
    var hasPromoBanner = (0,fp.some)({
        type: "offerStrip"
    }, sections);
    var sectionsWithAwardTiles = reduceWithIndex(function(sectionsWithAwards, section, index) {
        var startingPosition = hasPromoBanner ? 2 : 1;
        var newIndex = index + 1;
        var relativePositionFromStart = newIndex - startingPosition;
        var shouldAddAward = relativePositionFromStart % SPACE_BETWEEN_TILES === 0;
        var indexOfAward = Math.floor(relativePositionFromStart / SPACE_BETWEEN_TILES);
        var awardToAdd = shouldAddAward ? limitedAwardTiles[indexOfAward] : null;
        return (0,_to_consumable_array/* default */.Z)(sectionsWithAwards).concat([
            section
        ], (0,_to_consumable_array/* default */.Z)(awardToAdd ? [
            awardToAdd
        ] : []));
    }, // @ts-expect-error - Automatic, Please fix when editing this file
    INITIAL_VALUE, sections);
    return (0,fp.compact)(sectionsWithAwardTiles);
};
/* harmony default export */ var insert_award_tiles = (insertAwardTiles);

;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-awards-content/index.ts





var mapAwardsContent = function(param) {
    var awards = param.awards, sections = param.sections;
    if ((0,fp.isEmpty)(awards)) {
        return sections;
    }
    var mappedAwardTiles = (0,fp.map)(function(award) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, award), {
            type: content_sections/* CONTENT_SECTIONS.AWARD */.i.AWARD
        });
    }, awards);
    return insert_award_tiles({
        awardTiles: mappedAwardTiles,
        sections: sections
    });
};
/* harmony default export */ var map_awards_content = (mapAwardsContent);

;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-common-questions-alternate-content/index.ts




var mapCommonQuestionsAlternateContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    return {
        image: (0,get_image_attributes/* default */.Z)({
            height: 480,
            imageObject: cmsSectionContent === null || cmsSectionContent === void 0 ? void 0 : cmsSectionContent.imageObject
        }),
        isTwoColumn: true,
        items: (0,get_formatted_question_for_accordion/* default */.Z)(cmsSectionContent === null || cmsSectionContent === void 0 ? void 0 : cmsSectionContent.questions),
        summary: cmsSectionContent === null || cmsSectionContent === void 0 ? void 0 : cmsSectionContent.summaryRaw,
        title: cmsSectionContent === null || cmsSectionContent === void 0 ? void 0 : cmsSectionContent.title,
        type: content_sections/* CONTENT_SECTIONS.COMMON_QUESTIONS_ALTERNATE */.i.COMMON_QUESTIONS_ALTERNATE
    };
};
/* harmony default export */ var map_common_questions_alternate_content = (mapCommonQuestionsAlternateContent);

// EXTERNAL MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-common-questions-content/index.ts
var map_common_questions_content = __webpack_require__(54310);
;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-contact-details-content/index.ts




var mapContactDetailsContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cmsSectionContent), {
        type: content_sections/* CONTENT_SECTIONS.CONTACT_DETAILS */.i.CONTACT_DETAILS
    });
};
/* harmony default export */ var map_contact_details_content = (mapContactDetailsContent);

;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-core-benefits-content/index.ts




var mapCoreBenefitsContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent, insuranceType = param.insuranceType;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    var formattedBenefits = (0,fp.map)(function(coreBenefit) {
        var ref, ref1, ref2, ref3;
        return {
            cta: {
                title: (coreBenefit === null || coreBenefit === void 0 ? void 0 : (ref = coreBenefit.urlObject) === null || ref === void 0 ? void 0 : ref.name) ? coreBenefit === null || coreBenefit === void 0 ? void 0 : (ref1 = coreBenefit.urlObject) === null || ref1 === void 0 ? void 0 : ref1.name : null,
                to: (coreBenefit === null || coreBenefit === void 0 ? void 0 : (ref2 = coreBenefit.urlObject) === null || ref2 === void 0 ? void 0 : ref2.url) ? coreBenefit === null || coreBenefit === void 0 ? void 0 : (ref3 = coreBenefit.urlObject) === null || ref3 === void 0 ? void 0 : ref3.url : null
            },
            description: portable_text_to_plain_default()(coreBenefit.summaryRaw),
            image: (0,get_image_attributes/* default */.Z)({
                imageObject: coreBenefit.imageObject
            }),
            title: coreBenefit.name
        };
    }, cmsSectionContent.benefits);
    return {
        content: {
            benefits: formattedBenefits,
            slogan: portable_text_to_plain_default()(cmsSectionContent.sloganRaw)
        },
        insuranceType: insuranceType,
        type: content_sections/* CONTENT_SECTIONS.CORE_BENEFITS */.i.CORE_BENEFITS
    };
};
/* harmony default export */ var map_core_benefits_content = (mapCoreBenefitsContent);

;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-cross-sell-content/index.ts




var mapCrossSellContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent, insuranceType = param.insuranceType;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    var formattedContent = (0,fp.map)(function(contentItems) {
        var descriptionRaw = contentItems.descriptionRaw, name = contentItems.name, rootUrl = contentItems.rootUrl, tileImage = contentItems.tileImage;
        var description = portable_text_to_plain_default()(descriptionRaw);
        var image = tileImage ? (0,get_image_attributes/* default */.Z)({
            imageObject: tileImage,
            width: 240
        }) : null;
        var sortedContent = {
            cta: {
                title: "Find out more",
                to: rootUrl
            },
            description: description,
            image: image,
            name: "".concat(name, " insurance")
        };
        return sortedContent;
    }, cmsSectionContent);
    return {
        content: formattedContent,
        insuranceType: insuranceType,
        type: content_sections/* CONTENT_SECTIONS.CROSS_SELL */.i.CROSS_SELL
    };
};
/* harmony default export */ var map_cross_sell_content = (mapCrossSellContent);

;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-features-and-benefits/index.ts



// @ts-expect-error - Automatic, Please fix when editing this file
var mapFeaturesAndBenefits = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    return (0,_object_spread/* default */.Z)({
        type: content_sections/* CONTENT_SECTIONS.FEATURES_AND_BENEFITS */.i.FEATURES_AND_BENEFITS
    }, cmsSectionContent);
};
/* harmony default export */ var map_features_and_benefits = (mapFeaturesAndBenefits);

;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-forms-and-guides-content/index.ts




// @ts-expect-error - Automatic, Please fix when editing this file
var mapFormsAndGuidesContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cmsSectionContent), {
        type: content_sections/* CONTENT_SECTIONS.FORMS_AND_GUIDES */.i.FORMS_AND_GUIDES
    });
};
/* harmony default export */ var map_forms_and_guides_content = (mapFormsAndGuidesContent);

// EXTERNAL MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-header-content/index.ts
var map_header_content = __webpack_require__(15543);
// EXTERNAL MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-offer/index.ts
var map_offer = __webpack_require__(63086);
;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-products-content/index.ts


var HARDCODED_TITLE = "Choose cover that works for you";
var mapProductContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent, hasTargetMarket = param.hasTargetMarket;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    var targetMarketContent = cmsSectionContent === null || cmsSectionContent === void 0 ? void 0 : cmsSectionContent.find(function(content) {
        var ref;
        return content.productType === (hasTargetMarket === null || hasTargetMarket === void 0 ? void 0 : (ref = hasTargetMarket.identifier) === null || ref === void 0 ? void 0 : ref.current);
    });
    return {
        content: (0,fp.isNil)(targetMarketContent) ? cmsSectionContent : [
            targetMarketContent
        ],
        title: HARDCODED_TITLE,
        type: content_sections/* CONTENT_SECTIONS.PRODUCTS */.i.PRODUCTS
    };
};
/* harmony default export */ var map_products_content = (mapProductContent);

;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-promotions/index.ts


var mapPromotions = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    var promotions = cmsSectionContent;
    return (0,fp.isEmpty)(promotions) ? null : {
        promotions: promotions,
        type: content_sections/* CONTENT_SECTIONS.PROMOTIONS */.i.PROMOTIONS
    };
};
/* harmony default export */ var map_promotions = (mapPromotions);

;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-quick-links/index.ts




var map_quick_links_HARDCODED_TITLE = "Handy Links";
var mapQuickLinks = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cmsSectionContent), {
        title: map_quick_links_HARDCODED_TITLE,
        type: content_sections/* CONTENT_SECTIONS.QUICK_LINKS */.i.QUICK_LINKS
    });
};
/* harmony default export */ var map_quick_links = (mapQuickLinks);

// EXTERNAL MODULE: ./src/client/utils/map-terms-and-conditions-content/index.ts
var map_terms_and_conditions_content = __webpack_require__(24725);
// EXTERNAL MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-tiles/index.ts
var map_tiles = __webpack_require__(77013);
// EXTERNAL MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/map-value-propositions-content/index.ts
var map_value_propositions_content = __webpack_require__(17146);
;// CONCATENATED MODULE: ./src/client/pages/insurance/utils/combine-content-with-cms-data/index.ts


























var reduceWithKeys = (0,uncap_fp_iterator/* default */.Z)(fp.reduce);
var combineContentWithCmsData = function(param) {
    var cmsData = param.cmsData, staticContent = param.staticContent;
    var ref;
    var mergedData = (0,_object_spread/* default */.Z)({}, staticContent, cmsData);
    if ((0,fp.isEmpty)(mergedData)) {
        return {
            sections: []
        };
    }
    var insuranceType = cmsData === null || cmsData === void 0 ? void 0 : (ref = cmsData.identifier) === null || ref === void 0 ? void 0 : ref.current;
    var insuranceName = cmsData === null || cmsData === void 0 ? void 0 : cmsData.name;
    var formattedSections = reduceWithKeys(function(result, section, key) {
        var staticSectionContent = (0,fp.find)({
            type: section
        }, staticContent === null || staticContent === void 0 ? void 0 : staticContent.sections);
        // @ts-expect-error - Automatic, Please fix when editing this file
        var cmsSectionContent = cmsData === null || cmsData === void 0 ? void 0 : cmsData[content_sections/* CMS_CONTENT_SECTIONS */.f[key]];
        var offerData = cmsData === null || cmsData === void 0 ? void 0 : cmsData.offer;
        var hasTargetMarket = cmsData === null || cmsData === void 0 ? void 0 : cmsData.marketSegment;
        var sectionContent;
        switch(section){
            case content_sections/* CONTENT_SECTIONS.HEADER */.i.HEADER:
                sectionContent = (0,map_header_content/* default */.Z)({
                    cmsSectionContent: cmsSectionContent,
                    insuranceType: insuranceType,
                    offerData: offerData
                });
                break;
            case content_sections/* CONTENT_SECTIONS.PROMOTIONS */.i.PROMOTIONS:
                sectionContent = map_promotions({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.OFFER_STRIP */.i.OFFER_STRIP:
                sectionContent = (0,map_offer/* default */.Z)({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.CORE_BENEFITS */.i.CORE_BENEFITS:
                sectionContent = map_core_benefits_content({
                    cmsSectionContent: cmsSectionContent,
                    insuranceType: insuranceType
                });
                break;
            case content_sections/* CONTENT_SECTIONS.VALUE_PROPOSITIONS */.i.VALUE_PROPOSITIONS:
                sectionContent = (0,map_value_propositions_content/* default */.Z)({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.FEATURES_AND_BENEFITS */.i.FEATURES_AND_BENEFITS:
                sectionContent = map_features_and_benefits({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.FORMS_AND_GUIDES */.i.FORMS_AND_GUIDES:
                sectionContent = map_forms_and_guides_content({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.CONTACT_DETAILS */.i.CONTACT_DETAILS:
                sectionContent = map_contact_details_content({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.TILES */.i.TILES:
                sectionContent = (0,map_tiles/* default */.Z)({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.COMMON_QUESTIONS */.i.COMMON_QUESTIONS:
                sectionContent = (0,map_common_questions_content/* default */.Z)({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.COMMON_QUESTIONS_ALTERNATE */.i.COMMON_QUESTIONS_ALTERNATE:
                sectionContent = map_common_questions_alternate_content({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.TERMS_AND_CONDITIONS */.i.TERMS_AND_CONDITIONS:
                sectionContent = (0,map_terms_and_conditions_content/* default */.Z)({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.QUICK_LINKS */.i.QUICK_LINKS:
                sectionContent = map_quick_links({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.PRODUCTS */.i.PRODUCTS:
                sectionContent = map_products_content({
                    cmsSectionContent: cmsSectionContent,
                    hasTargetMarket: hasTargetMarket
                });
                break;
            case content_sections/* CONTENT_SECTIONS.CROSS_SELL */.i.CROSS_SELL:
                sectionContent = map_cross_sell_content({
                    cmsSectionContent: cmsSectionContent,
                    insuranceType: insuranceName
                });
                break;
            case content_sections/* CONTENT_SECTIONS.ADD_ONS */.i.ADD_ONS:
            case content_sections/* CONTENT_SECTIONS.RELEVANT_ADD_ONS */.i.RELEVANT_ADD_ONS:
                sectionContent = map_add_ons_content({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            case content_sections/* CONTENT_SECTIONS.ARTICLES */.i.ARTICLES:
                sectionContent = map_articles({
                    cmsSectionContent: cmsSectionContent
                });
                break;
            default:
                sectionContent = staticSectionContent;
        }
        // @ts-expect-error - Automatic, Please fix when editing this file
        return (0,_to_consumable_array/* default */.Z)(result).concat([
            sectionContent
        ]);
    }, [], content_sections/* CONTENT_SECTIONS */.i);
    var metaData = get_meta_data(mergedData, staticContent);
    var awardTiles = mergedData === null || mergedData === void 0 ? void 0 : mergedData.award;
    var filteredSections = (0,fp.compact)(formattedSections);
    var allQuestions = (0,get_formatted_question_for_accordion/* default */.Z)(get_all_questions({
        cmsData: mergedData
    }));
    var sectionsWithAwardTiles = map_awards_content({
        awards: awardTiles || null,
        sections: filteredSections
    });
    var mergedContent = (0,fp.flow)((0,fp.set)("sections", sectionsWithAwardTiles), (0,fp.set)("metadataObject", metaData), (0,fp.set)("faqQuestions", allQuestions))(mergedData);
    return mergedContent;
};
/* harmony default export */ var combine_content_with_cms_data = (combineContentWithCmsData);


/***/ }),

/***/ 24725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _pages_insurance_content_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58699);
/* harmony import */ var _map_terms_and_conditions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96816);



// @ts-expect-error - Automatic, Please fix when editing this file
var mapTermsAndConditionsContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(cmsSectionContent)) {
        return null;
    }
    var mappedTermsAndConditions = {
        terms: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flatMap)(_map_terms_and_conditions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, cmsSectionContent),
        type: _pages_insurance_content_sections__WEBPACK_IMPORTED_MODULE_1__/* .CONTENT_SECTIONS.TERMS_AND_CONDITIONS */ .i.TERMS_AND_CONDITIONS
    };
    return mappedTermsAndConditions;
};
/* harmony default export */ __webpack_exports__["Z"] = (mapTermsAndConditionsContent);


/***/ }),

/***/ 85500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X5": function() { return /* binding */ scrollTo; },
/* harmony export */   "kI": function() { return /* binding */ scrollToElement; },
/* harmony export */   "wA": function() { return /* binding */ getScrollPosition; }
/* harmony export */ });
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_is_server__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41105);


// Due to Firefox / Chrome following different standards. https://miketaylr.com/posts/2014/11/document-body-scrollTop.html
function getScrollPosition() {
    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
}
function scrollTo() {
    var to = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var isServer = (0,_get_is_server__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    if (isServer) {
        return;
    }
    window.scrollTo({
        behavior: "smooth",
        top: to
    });
    // this is used for `back to top` button after being clicked, return tab order to where it has id `backToTopPoint`
    var backToTopPoint = document.getElementById("backToTopPoint");
    if (backToTopPoint) {
        backToTopPoint.focus({
            preventScroll: true
        });
    }
}
function scrollToElement(element) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNull)(element)) {
        return;
    }
    var scrollPosition = element.getBoundingClientRect().top + getScrollPosition() + offset;
    scrollTo(scrollPosition);
}


/***/ })

}]);